import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    getCurrentUserIsGuest,
    getDefaultPageSize,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import setCurrentShipTo from "@insite/client-framework/Store/Context/Handlers/SetCurrentShipTo";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTo";
import loadShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";
import {
    getCurrentShipTosDataView,
    getShipTosDataView,
    getShipToState,
} from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import updateBillTo from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateBillTo";
import updateShipTo from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";
import translate from "@insite/client-framework/Translate";
import {
    BaseAddressModel,
    BillToModel,
    CartModel,
    CartLineModel,
    CustomerValidationDto,
    PickUpLocation,
    ShipToModel,
} from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BillingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/BillingAddress";
import { PickUpAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/PickUpAddress";
import { ShippingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress";
import Button, { ButtonPresentationProps, ButtonWrapper } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import { StyledButton } from "@insite/mobius/Clickable";
import { DatePickerPresentationProps } from "@insite/mobius/DatePicker";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Radio, { RadioProps, RadioStyle } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import Select, { SelectProps } from "@insite/mobius/Select";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useRef, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import siteMessage from "@insite/client-framework/SiteMessage";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import EditExistingAddressModal from "@insite/content-library/Widgets/CheckoutShipping/EditExistingAddressModal";
import ADIBillingAddress from "@NA/Components/ADIBillingAddress";
import ADIShippingAddress from "@NA/Components/ADIShippingAddress";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import cloneDeep from "lodash/cloneDeep";
import updateCart, { ADIUpdateCartResult } from "@NA/Handlers/ADIUpdateCartHandler";
import ADIColors from "@NA/Utils/ADIColors";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import ADIPickUpBranchDate from "@NA/Components/CheckoutShippingAddresses/ADIPickUpBranchDate";
import loadShippingMethods from "@NA/Handlers/ADIGetShippingMethodHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { DeliveryCarrier, DeliveryMethod, ShippingMethodsResults } from "@NA/Services/ADIShippingService";
import { getProp } from "@insite/mobius/utilities";
import setShippingMethod from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetShippingMethod";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import removeCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import checkoutCart, { CheckoutCartParameter } from "@NA/Handlers/ADICheckoutCartHandler";
import setUpdateCartLoading from "@NA/Handlers/ADIUpdateCartLoadingHandler";
import { HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import updateAlternateShip from "@NA/Handlers/ADICheckoutAlternateShipHandler";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import applyPromotion from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/ApplyPromotion";
import { useDispatch } from "react-redux";
import ADICannotShipModal from "@NA/Components/ADICannotShipModal";
import { isFreeShipPromoApplied, isHourBefore, negitiveOffsetADITime } from "@NA/Utilities/CheckoutUtilities";
import loadCartSummary from "@NA/Handlers/ADIGetCartSummaryMethodHandler";
import { LoadCartApiInterface } from "@NA/Handlers/LoadCartExtended";
import setPromotionState from "@NA/Handlers/ADIPromotionStateHandler";
import { isCodCustomer } from "@NA/Utilities/CheckoutUtilities";
import WarningRedIcon from "@NA/Icons/WarningRedIcon";
import { updateCartCalculationWithNewCart } from "@NA/Utilities/CheckoutUtilities";
import { CartSummaryMethodsResults } from "@NA/Services/ADICartSummaryService";
import { checkoutmodalpopup, compareAddress, replaceZeroPriceWithFree } from "@NA/Utils/Utility";

const mapStateToProps = (state: CustomApplicationState) => {
    const { cartId } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const defaultPageSize = getDefaultPageSize(state);
    const deliveryMethods = state.ADIGlobalData.shippingMethodStore?.shippingMethods?.deliveryMethod;
    const shipTosDataView = cart
        ? getShipTosDataView(state, {
            billToId: cart.billToId,
            expand: ["validation"],
            exclude: ["showAll", "billTo", "oneTime", "createNew"],
        })
        : undefined;
    const shitos = state.pages.checkoutShipping.billingAddressFormState?.address.shipTos;
    //const cartIsLoading = state.ADIGlobalData.ADIUpdateCartLoading.loading || cartState?.isLoading;
    const isCartUpdating = state.ADIGlobalData.ADIUpdateCartLoading.loading || cartState?.isLoading;

    let newAddress;
    let oneTimeAddress;
    let isShipToSameAsBillTo = false;
    let canUseBillToAsShipTo = false;
    let currentShipTo;
    if (cart && cart.cartLines && shipTosDataView && shipTosDataView.value) {
        const shipTos = shipTosDataView.value;
        newAddress = shipTos!.find(s => s.isNew && !s.oneTimeAddress);
        oneTimeAddress = shipTos!.find(s => s.oneTimeAddress);
        isShipToSameAsBillTo = cart.billToId === cart.shipToId;
        canUseBillToAsShipTo = shipTos!.some(shipTo => shipTo.id === cart.billToId);
        currentShipTo = shipTos;
    }

    return {
        cart,
        state,
        shitos,
        deliveryMethods,
        newAddress,
        oneTimeAddress,
        shipToState: getShipToState(state, cart ? cart.shipToId : undefined),
        shipTosDataView,
        currentShipTo,
        isShipToSameAsBillTo,
        countries: getCurrentCountries(state),
        shipToAddressFields: getAddressFieldsDataView(state).value?.shipToAddressFields,
        billToAddressFields: getAddressFieldsDataView(state).value?.billToAddressFields,
        accountSettings: getSettingsCollection(state).accountSettings,
        canUseBillToAsShipTo,
        currentUserIsGuest: getCurrentUserIsGuest(state),
        useBillingAddress: state.pages.checkoutShipping.useBillingAddress,
        billToState: getBillToState(state, cart?.billToId),
        cartPageLink: getPageLinkByPageType(state, "CartPage")?.url || "",
        pickUpLocationStates: cart?.pickUpLocations,
        currentShipTosDataView: getCurrentShipTosDataView(state),
        shipTosDataViewEdit: getShipTosDataView(state, {
            billToId: cart?.billToId,
            expand: ["validation"],
            exclude: ["showAll"],
        }).value,
        shippingMethods: state.ADIGlobalData.shippingMethodStore.shippingMethods,
        shippingMethodStore: state.ADIGlobalData.shippingMethodStore,
        shippingMethodsLoading: state.ADIGlobalData.shippingMethodStore.isLoading,
        localCart: state.ADIGlobalData.checkoutCartStore.cart,
        paymentMethod: state.ADIGlobalData.checkoutCartStore.paymentMethod,
        defaultPageSize,
        sessionShipTO: getShipToState(state, state.context.session.shipToId),
        sessionShipToId: state.context.session.shipToId,
        alternateShipAddress: state.ADIGlobalData.checkoutCartStore.alternateShipTo,
        location: getLocation(state),
        //isCartLoading: state.ADIGlobalData.ADIUpdateCartLoading.loading,
        cartIsLoading: state.ADIGlobalData.ADIUpdateCartLoading.loading,
        alternateAddressRemoved: state.ADIGlobalData.shippingMethodStore.alternateAddressRemoved,
        promoAppliedBtnclicked: state.ADIGlobalData.shippingMethodStore.promoAppliedBtnclicked,
        initialPickUpDate: state.ADIGlobalData.shippingMethodStore.initialPickUpDate,
        cartLoaded: state.data.carts.isLoading,
        isCartUpdating,
    };
};

const mapDispatchToProps = {
    updateShipTo,
    setCurrentShipTo,
    loadShipTo,
    loadShipTos,
    updateAlternateShip,
    updateBillTo,
    loadCart,
    loadShippingMethods,
    removeCartLine,
    setShippingMethod,
    loadCurrentCart,
    checkoutCart,
    setUpdateCartLoading,
    applyPromotion,
    updateCart,
    setPromotionState,
    loadCartSummary,
};

type BaseAddressModelWithValidation = BaseAddressModel & { validation?: CustomerValidationDto | null };
interface OwnProps {
    onEdit?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, customer: BaseAddressModel) => void;
    customer: BaseAddressModelWithValidation;
    onChange: (address: ShipToModel) => void;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface ADICheckoutShippingAddressesStyles {
    loadingWrapper?: InjectableCss;
    dgDataHead?: InjectableCss;
    availabilityByWarehouseModal?: ModalPresentationProps;
    modalDescription?: InjectableCss;
    dgDataContainer?: InjectableCss;
    adiPartHeader?: InjectableCss;
    adiPartContainer?: InjectableCss;
    buttonContainer?: InjectableCss;
    removeItemButton?: InjectableCss;
    pickUpInBranchButton?: InjectableCss;
    adiModelHeader?: InjectableCss;
    adiModelContainer?: InjectableCss;
    adiDescHeader?: InjectableCss;
    adiDescContainer?: InjectableCss;
    deliveryMethodContainer?: GridContainerProps;
    pickUpContainer?: GridContainerProps;
    shippingAddressGridItem?: GridItemProps;
    shippingAddress?: ShippingAddressStyles;
    billingAddressGridItem?: GridItemProps;
    billingAddress?: BillingAddressStyles;
    pickUpAddress?: PickUpAddressStyles;
    shipAddressGridItem?: GridItemProps;
    alternateShipAddressGridItem?: GridItemProps;
    alternateShipAddressGridItemPickUp?: GridItemProps;
    alternateShipLeftGrid?: GridItemProps;
    alternateShipLeftGridPickUp?: GridItemProps;
    alternateShipRightGrid?: GridItemProps;
    alternateShipRightGridPickUp?: GridItemProps;
    alternateShipButtonGrid?: GridItemProps;
    newAddressButton?: ButtonPresentationProps;
    selectAddressButton?: ButtonPresentationProps;
    pickUpBranchGridItem?: GridItemProps;
    pickUpBranchGridItemPickUp?: GridItemProps;
    pickUpBranchRightGridItem?: GridItemProps;
    pickUpCheckboxGridItem?: GridItemProps;
    pickUpRadioGridItem?: GridItemProps;
    stateStyles?: InjectableCss;
    datepickerStyles?: DatePickerPresentationProps;
    adiLockerModal?: ModalPresentationProps;
    adiLockerBodyContainer?: InjectableCss;
    adiLockerButtonContainer?: InjectableCss;
    tooltipStyles?: TooltipPresentationProps;
    pickUpStyles?: InjectableCss;
    radioContainer?: GridContainerProps;
    customBorder?: InjectableCss;
    shippingMethodsContainer?: GridContainerProps;
    shippingContent?: GridItemProps;
    shippingTitle?: GridItemProps;
    shippingOptionsContainer?: GridItemProps;
    selectedTitle?: TypographyProps;
    optionsTitle?: TypographyProps;
    carrierTitle?: TypographyProps;
    radioOptions?: RadioProps;
    selectTime?: SelectProps;
    shippingTypeText?: TypographyProps;
    onehourCheckboxGridItem?: GridItemProps;
    ltlTextGrid?: GridItemProps;
    spinner?: LoadingSpinnerProps;
    shippingOptionsInnerContainer?: InjectableCss;
    shippingUPSOptionsInnerContainer?: InjectableCss;
    radioGroupStyles?: RadioGroupProps;
    modal?: ModalPresentationProps;
}

export const adiCheckoutShippingAddressesStyles: ADICheckoutShippingAddressesStyles = {
    spinner: {
        size: 22,
        css: css`
            position: relative;
            top: 10px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        `,
    },
    pickUpContainer: {
        css: css`
            > ${GridOffset} {
                width: 100%;
                align-items: center;
            }
        `,
    },
    modalDescription: {
        css: css`
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 15px;
            color: ${ADIColors.darkBlack2};
        `,
    },
    availabilityByWarehouseModal: {
        sizeVariant: "medium",
        cssOverrides: {
            modalBody: css`
                max-width: 1061px !important;
                border-radius: 4px;
                padding: 28px !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: calc(100% - 30px);
                            height: auto;
                            max-height: calc(100% - 30px);
                            padding: 15px !important;
                        `,
                        css`
                            width: calc(100% - 30px);
                            height: auto;
                            max-height: (100% - 30px);
                            padding: 10px !important;
                        `,
                        css`
                            top: 15%;
                            position: absolute;
                            width: calc(100% - 100px);
                            height: auto;
                            max-height: (100% - 100px);
                            padding: 10px !important;
                        `,
                        null,
                        null,
                    ])}
            `,
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 0 !important;
                margin-bottom: 20px;
                > h4 {
                    font-size: 34px;
                    font-weight: 900;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 36px;
                    letter-spacing: normal;
                    color: ${ADIColors.darkBlue1};
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                                font-size: 20px;
                                line-height: 24px;
                            `,
                        css`
                                font-size: 20px;
                                line-height: 24px;
                            `,
                        css`
                                font-size: 20px;
                                line-height: 24px;
                            `,
                        null,
                        null,
                    ])}
                }
                button {
                    border-radius: 0;
                    display: none;
                    svg {
                        height: 20px;
                    }
                }
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    dgDataHead: {
        css: css`
            display: flex;
        `,
    },
    dgDataContainer: {
        css: css`
            display: flex;
            background-color: ${ADIColors.brightGray1};
        `,
    },
    adiPartHeader: {
        css: css`
            width: 20%;
            font-size: 16px;
            line-height: 22px;
            padding: 9px 23px;
            color: ${ADIColors.black};
            font-weight: bold;
        `,
    },
    adiPartContainer: {
        css: css`
            width: 20%;
            color: ${ADIColors.darkBlack3};
            font-size: 16px;
            line-height: 22px;
            padding: 9px 23px;
            display: inline-flex;
            justify-content: flex-start;
            align-items: center;
        `,
    },
    adiModelHeader: {
        css: css`
            width: 25%;
            font-size: 16px;
            line-height: 22px;
            padding: 9px 23px;
            color: ${ADIColors.black};
            font-weight: bold;
        `,
    },
    adiModelContainer: {
        css: css`
            width: 25%;
            color: ${ADIColors.darkBlack3};
            font-size: 16px;
            line-height: 22px;
            padding: 9px 23px;
            display: inline-flex;
            justify-content: flex-start;
            align-items: center;
        `,
    },
    adiDescHeader: {
        css: css`
            width: 55%;
            font-size: 16px;
            line-height: 22px;
            padding: 9px 23px;
            color: ${ADIColors.black};
            font-weight: bold;
        `,
    },
    adiDescContainer: {
        css: css`
            width: 55%;
            color: ${ADIColors.darkBlack3};
            font-size: 16px;
            line-height: 22px;
            padding: 9px 23px;
            display: inline-flex;
            justify-content: flex-start;
            align-items: center;
        `,
    },
    buttonContainer: {
        css: css`
            margin-top: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        align-items: center;
                        gap: 10px;
                        flex-direction: column;
                        display: flex;
                        > ${ButtonWrapper} {
                            min-width: 220px;
                            margin-left: 0px;
                        }
                    `,
                    css`
                        align-items: center;
                        gap: 10px;
                        flex-direction: column;
                        display: flex;
                        > ${ButtonWrapper} {
                            min-width: 220px;
                            margin-left: 0px;
                        }
                    `,
                    css`
                        ${ButtonWrapper} {
                            span {
                                font-size: 14px;
                            }
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    removeItemButton: {
        css: css`
            box-shadow: inset 0 -4px 0 0 ${ADIColors.blue5};
            background-color: ${ADIColors.blue5};
            border-radius: 7px;
            padding: 0;
            min-height: 40px;
            height: auto;
            text-transform: uppercase;
            font-size: 14px;
            min-width: 219px;
            font-weight: 800;
            &:hover {
                background-color: ${ADIColors.blue5};
                border-color: ${ADIColors.blue5};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        span {
                            font-size: 14px;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    pickUpInBranchButton: {
        css: css`
            margin-left: 20px;
            border: solid 2px ${ADIColors.blue1};
            background-color: ${ADIColors.white};
            > span {
                color: ${ADIColors.blue1};
            }
            &:hover {
                border: solid 2px ${ADIColors.blue1};
                background-color: ${ADIColors.white};
                > span {
                    color: ${ADIColors.blue1};
                }
            }
        `,
    },
    adiLockerBodyContainer: {
        css: css`
            overflow-y: auto;
            min-height: inherit;
            max-height: 62vh;
            padding-right: 18px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-right: 6px;
                    `,
                    css`
                        padding-right: 6px;
                    `,
                    null,
                    null,
                    null,
                ])}
            &::-webkit-scrollbar {
                width: 8px;
                overflow-y: auto;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            width: 4px;
                        `,
                    css`
                            width: 4px;
                        `,
                    null,
                    null,
                    null,
                ])}
            }
            &::-webkit-scrollbar-track {
                background: ${getColor("text.disabled")};
                overflow-y: auto;
            }
            &::-webkit-scrollbar-thumb {
                background-color: ${ADIColors.lightGrey};
                border-radius: 7px;
                overflow-y: auto;
            }
            > ${TypographyStyle} {
                color: ${ADIColors.black};
            }
            ul {
                li {
                    color: ${ADIColors.black};
                }
            }
        `,
    },
    customBorder: {
        css: css`
            border-bottom: 1px solid ${getColor("text.disabled")};
            width: calc(100% + 50px);
            // margin: 27px 0 21.5px -24px;
            margin: 27px -10px 0px -9px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0px;
                            margin: 0px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    radioContainer: {
        css: css`
            ${GridItemStyle} {
                ${RadioStyle} {
                    label {
                        font-weight: bold;
                        font-size: ${getProp("theme.typography.h6.size")};
                        cursor: pointer;
                        text-wrap: nowrap;
                        margin-top: 10px;
                    }
                }
            }
        `,
    },
    pickUpStyles: {
        css: css`
            width: 28px;
        `,
    },
    tooltipStyles: {
        cssOverrides: {
            tooltipClickable: css`
                padding: 0 1px 3px 4px;
                &:focus {
                    outline-width: 0px;
                }
                > ${IconWrapper} {
                    color: ${getColor("primary")};
                    background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/newicons/tooltip_icon_default.svg)
                        no-repeat;
                    width: 15px;
                    height: 15px;
                    background-size: 100%;
                    padding: 0;
                    margin: 0.5px 0 0 5px;
                    vertical-align: top;
                    svg {
                        display: none;
                    }
                }
            `,
            tooltipContainer: css`
                z-index: 1;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                margin-left: -120px;
                                &::before,
                                &::after {
                                    left: 53%;
                                }
                            `,
                        ],
                        "max",
                    );
                }}
            `,
            tooltipBody: css`
                padding: 21px 13px;
                background: ${getColor("common.background")};
                color: ${getColor("text.main")};
                border: 1px solid ${ADIColors.gray3};
            `,
        },
    },
    adiLockerButtonContainer: {
        css: css`
            display: flex;
            justify-content: flex-end;
            > ${ButtonWrapper} {
                min-width: 222px;
                height: auto;
                min-height: 42px;
                border-radius: 4px;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                                min-width: 165px;
                            `,
                        css`
                                min-width: 165px;
                            `,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
        `,
    },
    adiLockerModal: {
        cssOverrides: {
            modalContainer: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                top: 12%;
                                position: fixed;
                                padding: 10px;
                            `,
                            css`
                                top: 12%;
                                position: fixed;
                                padding: 10px;
                                height: 85vh !important;
                            `,
                            null,
                            css`
                                height: 75vh;
                            `,
                            null,
                        ],
                        "max",
                    )}
            `,
            modalBody: css`
                border-radius: 6px;
                border: 1px solid ${getColor("common.border")};
                padding: 32px 10px 28px 25px;
                overflow-y: hidden;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 24px 10px 20px 20px;
                                margin: 0px !important;
                            `,
                            css`
                                padding: 24px 10px 20px 20px;
                                margin: 0px !important;
                            `,
                            css`
                                height: auto;
                                margin: 45px;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
            modalTitle: css`
                border: none;
                padding: 0px;
                margin: 0 0 16px 0;
                #CloseModalButton {
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                    position: relative;
                                    bottom: 32px;
                                `,
                            css`
                                    position: relative;
                                    bottom: 32px;
                                `,
                            css``,
                            null,
                            null,
                        ],
                        "max",
                    )}
                }
                button {
                    position: relative;
                    bottom: 20px;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                    position: relative;
                                    bottom: 32px;
                                `,
                            css`
                                    position: relative;
                                    bottom: 32px;
                                `,
                            css``,
                            null,
                            null,
                        ],
                        "max",
                    )}
                }
                > ${TypographyStyle} {
                    font-size: 28px; // not in stylguide

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                    font-size: 24px;
                                    margin: 0 0 0px 0;
                                `,
                            css`
                                    font-size: 24px;
                                    margin: 0 0 0px 0;
                                `,
                            css``,
                            null,
                            null,
                        ],
                        "max",
                    )}
                }
                > ${ButtonWrapper} {
                    &:hover {
                        background: transparent;
                        border-color: transparent;
                    }
                    &:focus {
                        outline: none;
                    }
                    > ${IconWrapper} {
                        color: ${getColor("primary")};
                        width: 35px;
                        height: 35px;
                        > svg {
                            width: 35px;
                            height: 35px;
                            stroke-width: 1px;
                        }
                    }
                }
            `,
            modalContent: css`
                padding: 0px;
                .firstLineText {
                    margin-bottom: 24px;
                    font-size: 16px;
                    span {
                        font-weight: bold;
                    }

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                    margin-bottom: 30px;
                                    font-size: 14px;
                                `,
                            css`
                                    margin-bottom: 30px;
                                    font-size: 14px;
                                `,
                            css``,
                            null,
                            null,
                        ],
                        "max",
                    )}
                }
                > ${TypographyStyle} {
                    font-size: ${getProp("theme.typography.h6.size")};
                    font-size: 14px;
                }
                ul {
                    margin-left: 34px;
                    margin-bottom: 28px;
                    list-style: disc;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                    margin-bottom: 7px;
                                `,
                            css`
                                    margin-bottom: 7px;
                                `,
                            css``,
                            null,
                            null,
                        ],
                        "max",
                    )}

                    li {
                        margin-bottom: 13px;
                        font-size: 16px;
                        ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                        font-size: 14px;
                                    `,
                            css`
                                        font-size: 14px;
                                    `,
                            css``,
                            null,
                            null,
                        ],
                        "max",
                    )}
                    }
                }
                .forQuestionsText {
                    margin-bottom: 28px;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                    margin-bottom: 20px;
                                `,
                            css`
                                    margin-bottom: 20px;
                                `,
                            css``,
                            null,
                            null,
                        ],
                        "max",
                    )}
                }
            `,
        },
    },
    datepickerStyles: {
        cssOverrides: {
            datePicker: css`
                > div {
                    > span {
                        > div {
                            > div {
                                right: 0 !important;
                                left: auto !important;
                            }
                        }
                    }
                }
            `,
            formInputWrapper: css`
                margin-top: 6px;
                padding-left: 1rem;
                .react-datetime-picker__inputGroup__leadingZero {
                    padding-left: 2px;
                    margin: 0px -1px 0px -1px;
                }
            `,
            inputSelect: css`
                min-height: 37px;
                padding: 0 10px 0 10px;
                font-size: 12px;
                width: max-content;
            `,
        },
    },
    stateStyles: {
        css: css`
            min-height: 37px;
            padding-right: 40px !important;
            font-family: Nunito Sans !important;
        `,
    },
    pickUpCheckboxGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            justify-content: center;
            padding-top: 0px;
            padding-left: calc(33.333% + 32px);
            justify-content: flex-start;
            margin-right: 0px;
            span[role="checkbox"] {
                & + label {
                    padding-top: 3px;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            justify-content: left;
                            padding-left: 32px;
                            padding-right: 0px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    onehourCheckboxGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            justify-content: center;
            padding-top: 0px;
            margin-right: 0px;
            padding-left: calc(33.333% + 32px);
            justify-content: flex-start;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            justify-content: left;
                            padding-left: 32px;
                            padding-right: 0px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    pickUpRadioGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            padding: 0px;
            padding-top: 0px;
            > ${RadioStyle} > input:disabled + label {
                cursor: not-allowed !important;
            }
            > ${RadioStyle} > input:disabled + label::after {
                cursor: not-allowed !important;
                background-color: transparent;
            }
            > ${RadioStyle} > input:disabled + label::before {
                cursor: not-allowed !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            flex-direction: column;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    pickUpBranchRightGridItem: {
        width: [12, 12, 12, 8, 8],
        css: css`
            padding-left: 2rem;
            > ${FormFieldStyle} {
                max-width: 13.6rem;
                > ${FormInputWrapper} {
                    select {
                        padding: 0 10px 0 15px;
                    }
                    ${IconWrapper} {
                        top: 7px;
                    }
                }
            }
            > div[class^="FormFieldStyle"] {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                                margin-left: 0px;
                            `,
                        null,
                    ],
                    "max",
                )}
            }
        `,
    },
    pickUpBranchGridItem: {
        width: [12, 12, 12, 12, 12],
    },
    pickUpBranchGridItemPickUp: {
        width: [12, 12, 12, 12, 12],
    },
    newAddressButton: {
        variant: "secondary",
    },
    alternateShipButtonGrid: {
        width: [12, 12, 12, 12, 12],
        css: css`
            padding: 0px;
            > ${ButtonWrapper} {
                padding: 0px 10px;
                &:nth-child(1) {
                    margin-right: 10px;
                }
            }
        `,
    },
    alternateShipAddressGridItem: {
        width: [12, 12, 12, 12, 6],
        css: css`
            padding-right: 0px;
        `,
    },
    alternateShipAddressGridItemPickUp: {
        width: [11, 11, 12, 12, 6],
        css: css`
            padding-right: 0px;
        `,
    },
    alternateShipLeftGrid: {
        width: [7, 7, 8, 8, 8],
        css: css`
            flex-direction: column;
            padding-bottom: 0px;
            ${RadioStyle} {
                label {
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                                    margin-left: -10px;
                                `,
                        css`
                                    margin-left: -10px;
                                `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
                }
            }
        `,
    },
    alternateShipLeftGridPickUp: {
        width: [6, 6, 8, 8, 8],
        css: css`
            flex-direction: column;
            padding-bottom: 0px;

            ${RadioStyle} {
                label {
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                                    margin-left: -10px;
                                `,
                        css`
                                    margin-left: -10px;
                                `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
                }
            }
        `,
    },
    alternateShipRightGrid: {
        width: [5, 5, 4, 4, 4],
        css: css`
            padding-right: 0px;
            align-items: center;
            padding-bottom: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            top: -6rem !important;
                            padding: 1.3rem 0 !important;
                        `,
                        css`
                            position: absolute;
                            padding: 1rem;
                            right: 0;
                            top: 0;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            >${StyledButton} {
                &:focus {
                    outline: none;
                }
                &:disabled {
                    cursor: default;
                    span {
                        &:hover {
                            text-decoration: none;
                            color: ${ADIColors.blue5};
                        }
                    }
                }
                span {
                    font-weight: bold;
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                    font-size: 14px;
                                `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
                    &:hover {
                        text-decoration: underline;
                    }
                }
                &:nth-child(1) {
                    margin-right: 7px;
                }
            }
        `,
    },
    alternateShipRightGridPickUp: {
        width: [6, 6, 4, 4, 4],
        css: css`
            padding-right: 0px;
            align-items: center;
            padding-bottom: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            top: -6rem !important;
                            padding: 1rem 0 !important;
                        `,
                        css`
                            position: absolute;
                            padding: 1rem;
                            right: 0;
                            top: 0;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            >${StyledButton} {
                &:focus {
                    outline: none;
                }
                &:disabled {
                    cursor: default;
                    span {
                        &:hover {
                            text-decoration: none;
                            color: ${ADIColors.blue5};
                        }
                    }
                }
                span {
                    font-weight: bold;
                    &:hover {
                        text-decoration: underline;
                    }
                }
                &:nth-child(1) {
                    margin-right: 7px;
                }
            }
        `,
    },
    shipAddressGridItem: {
        width: [12, 12, 12, 12, 6],
        css: css`
            flex-direction: column;
            padding-left: 10px;
        `,
    },
    loadingWrapper: {
        css: css`
            display: flex;
            height: 450px;
            justify-content: center;
            align-items: center;
        `,
    },
    shippingAddressGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            padding: 5px 0px 15px 30px;
        `,
    },
    billingAddressGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            padding-left: 35px;
        `,
    },
    shippingMethodsContainer: {
        css: css`
            ${GridOffset} {
                margin-top: 50px;
                width: 100%;
                margin: 0;
                padding-left: 10px;
                align-items: center;
            }
            > ${GridOffset} {
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                                margin-top: 20px;
                            `,
                    ],
                    "max",
                );
            }}
            }
        `,
    },
    shippingTitle: {
        width: [12, 12, 12, 4, 4],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 5px;
                    `,
                    css`
                        padding-bottom: 5px;
                    `,
                    css`
                        padding-bottom: 5px;
                    `,
                    css``,
                    null,
                ])}
            span {
                font-size: ${getProp("theme.typography.h6.size")};
                color: ${getColor("text.main")};
                font-weight: bold;
            }
        `,
    },
    shippingContent: {
        width: [12, 12, 12, 8, 8],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 0;
                        padding-bottom: 0;
                    `,
                    css`
                        padding-top: 0;
                        padding-bottom: 0;
                    `,
                    css`
                        padding-top: 0;
                        padding-bottom: 0;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    shippingOptionsContainer: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            z-index: 10;
            background-color: ${getColor("common.accent")};
            margin: 15px 16px 10px !important;
            padding: 15px 15px 5px;
        `,
    },
    shippingOptionsInnerContainer: {
        css: css`
            width: auto;
            min-width: 50%;
            display: inline-block;
            &:first-child {
                order: 2;
            }
        `,
    },
    shippingUPSOptionsInnerContainer: {
        css: css`
            width: auto;
            min-width: 50%;
            display: inline-block;
            &:last-child {
                order: 1;
            }
        `,
    },
    optionsTitle: {
        css: css`
            color: ${getColor("primary")};
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            padding-left: 10px;
            font-weight: bold;
            cursor: pointer;
            :hover {
                text-decoration: underline;
            }
        `,
    },
    selectedTitle: {
        css: css`
            font-size: ${getProp("theme.typography.headerSecondary.size")};
        `,
    },
    carrierTitle: {
        css: css`
            margin-bottom: 12px;
            font-size: 12px; // font not in styleguide
            font-weight: bold;
            color: ${getColor("text.main")};
            display: flex;
        `,
    },
    radioGroupStyles: {
        css: css`
            > ${RadioStyle} {
                > input[type^="radio"] {
                    margin-left: -2px;
                }
                input + label::before {
                    background-color: ${getColor("common.background")};
                }
                > ${TypographyStyle} {
                    font-size: 12px !important;
                    font-weight: normal !important;
                    margin-top: 0px !important;
                }
            }
        `,
    },
    selectTime: {
        css: css`
            width: 100%;
        `,
    },
    shippingTypeText: {
        css: css`
            width: 100%;
            display: block;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            margin-top: 4px;
            color: ${getColor("text.main")};
            font-weight: normal;
        `,
    },
    ltlTextGrid: {
        width: 12,
        css: css`
            span {
                font-size: ${getProp("theme.typography.h6.size")};
                color: ${getColor("text.main")};
                font-weight: bold;
            }
        `,
    },
    modal: {
        size: 930,
        cssOverrides: {
            modalBody: css`
                border-radius: 6px;
                overflow-y: visible;
                max-height: calc(80vh - 140px);
                overflow-x: hidden;
                // height: auto;
                overflow-y: auto;
                height: unset;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            max-width: calc(100% - 20px);
                            // min-height: 90vh;
                        `,
                        css`
                            max-width: calc(100% - 20px);
                            // min-height: 90vh;
                        `,
                        css`
                            max-width: 70%;
                            height: unset;
                        `,
                        null,
                        null,
                    ])}
            `,
            modalTitle: css`
                display: none;
                padding: 0;
            `,
            modalContent: css`
                padding: 40px 20px;
                overflow-y: auto;
                overflow-x: hidden;
                section {
                    margin-bottom: 0px;
                }
                &::-webkit-scrollbar {
                    width: 8px;
                    overflow-y: auto;
                }
                &::-webkit-scrollbar-track {
                    background: ${getColor("common.background")};
                    overflow-y: auto;
                }
                &::-webkit-scrollbar-thumb {
                    background-color: ${ADIColors.lightGrey};
                    border-radius: 7px;
                    overflow-y: auto;
                }
                .modalContainer {
                    display: flex;
                }
                .modalText {
                    padding-left: 10px;
                }
            `,
        },
    },
};

/**
 * @deprecated Use checkoutShippingAddressesStyles instead.
 */
export const fulfillmentMethodAndAddressStyles = adiCheckoutShippingAddressesStyles;
const styles = adiCheckoutShippingAddressesStyles;

const ADICheckoutShippingAddresses: FC<Props> = ({
    cart,
    shipToState,
    sessionShipTO,
    shipTosDataView,
    countries,
    shipToAddressFields,
    billToAddressFields,
    setCurrentShipTo,
    loadShipTo,
    currentShipTo,
    removeCartLine,
    loadShipTos,
    updateBillTo,
    billToState,
    updateShipTo,
    loadShippingMethods,
    canUseBillToAsShipTo,
    isShipToSameAsBillTo,
    newAddress,
    oneTimeAddress,
    updateAlternateShip,
    children,
    cartPageLink,
    history,
    pickUpLocationStates,
    shippingMethods,
    checkoutCart,
    localCart,
    applyPromotion,
    shitos,
    paymentMethod,
    alternateAddressRemoved,
    promoAppliedBtnclicked,
    initialPickUpDate,
    updateCart,
    setUpdateCartLoading,
    cartLoaded,
    cartIsLoading,
    setPromotionState,
    isCartUpdating,
    loadCartSummary,
    deliveryMethods,
}) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const [shippingSelectionState, setShippingSelection] = React.useState("primary");
    const [pickUpDate, setPickUpDate] = useState("");
    const [orderDate, setOrderDate] = useState<Date>(tomorrow);
    const [isOneHourPickup, setIsOneHourPickup] = useState(false);
    const [isShowOneHourPickup, setIsShowOneHourPickup] = useState(false);
    const [isPickUpSelected, setIsPickUpSelected] = useState(false);
    const [selectedState, setSelectedState] = useState<PickUpLocation | undefined>(
        pickUpLocationStates?.find(item => item.isDefault),
    );
    const currentShipState = useSelector((state: CustomApplicationState) => state.ADIGlobalData.shippingMethodStore);
    const [isAdiLockerModalOpen, setIsAdiLockerModalOpen] = useState(false);
    const [adiLockerCheck, setAdiLockerCheck] = useState(false);
    const [isEditAddressModalOpen, setIsEditAddressModalOpen] = useState(false);
    const [selectedDeliveryMethodValue, setSelectedDeliveryMethodValue] = useState<string | undefined>(undefined);
    const [selectedMoreOptionValue, setSelectedMoreOptionValue] = useState<string | undefined>(undefined);
    const [initialMoreOptionLoaded, setInitialMoreOptionLoaded] = useState(false);
    const [storeMoreOptionValue, setStoreMoreOptionValue] = useState<string | undefined>(undefined);

    const [selectedDeliveryMethodDisplay, setSelectedDeliveryMethodDisplay] = useState<DeliveryMethod | undefined>(
        undefined,
    );
    const [selectedShippingMethodValue, setSelectedShippingMethodValue] = useState<DeliveryMethod | undefined>(
        undefined,
    );
    const [showShippingOptions, setShowShippingOptions] = useState(false);
    const [shippingType, setShippingType] = useState("");
    const [formattedDate, setFormattedDate] = React.useState(pickUpDate.toString());

    const [showModal, setShowModal] = useState(false);
    const [isRadioDisabled, setIsRadioDisabled] = useState(false);
    const [lineIdToRemove, setLineIdToRemove] = useState<CartLineModel | undefined>();
    // removed it as part of ADINA-53793
    // const [hidePickUpInBranch, setHidePickUpInBranch] = useState(true);
    const [renderFirstTimeOnly, setRenderFirstTimeOnly] = useState(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [addressId, setAddressId] = useState("");
    const [selectedAltAddress, setSelectedAltAddress] = useState<ShipToModel | undefined>(undefined);
    const [initialShippingMethodsLoaded, setInitialShippingMethodsLoaded] = useState(true);
    const [initialShipTosLoaded, setInitialShipTosLoaded] = useState(false);
    const [disableADILockerCheckbox, setdisableADILockerCheckbox] = useState(false);
    const [updateDeliveryMethod, setUpdateDeliveryMethod] = useState(false);
    const [isTBD, setIsTBD] = useState(false);
    const toasterContext = React.useContext(ToasterContext);

    const isPRRegion = typeof window !== "undefined" && window.location.hostname.endsWith('.pr');
    const [cannotShipAirs, setCannotShipAirs] = useState("");
    const [selectCity, setSelectCity] = useState("");
    const [selectState, setSelectState] = useState("");
    const [selectPostalCode, setSelectPostalCode] = useState("");
    const [selectHasBulkItem, setSelectHasBulkItem] = useState(false);
    const [selectHasShipLTL, setSelectHasShipLTL] = useState(false);
    const [selectShippingWeights, setSelectShippingWeights] = useState(Number);

    const dispatch = useDispatch();

    const modalCloseHandler = () => {
        setShowModal(false);
    };

    const isLbProductPresntInCart = cart?.cartLines?.some(e => e.properties?.logicBroker?.toLowerCase() === "yes");

    const editCustomerHandler = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        setIsEditAddressModalOpen(true);
    };
    const targetRef = React.useRef<HTMLDivElement>(null);
    let lastHeight = 0;
    useEffect(() => {
        if (targetRef.current && showShippingOptions && window.innerWidth > 1200) {
            const height = targetRef.current.offsetHeight + 45;
            if (height !== lastHeight) {
                sessionStorage.setItem("leftSideMoreoptDivHeight", String(height));
                lastHeight = height;
            }
        } else {
            sessionStorage.setItem("leftSideMoreoptDivHeight", String(0));
        }
    }, [showShippingOptions]);

    useEffect(() => {
        const inputDate = new Date(orderDate?.toDateString());
        const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
        const day = inputDate.getDate().toString().padStart(2, "0");
        const year = inputDate.getFullYear().toString().slice(2);
        const formattedDate = `${year}${month}${day}`;
        setFormattedDate(formattedDate);
    }, []);

    const [isAdonisDown, setIsAdonisDown] = useState(false);
    const [messageFlag, setIsMessageFlag] = useState("");

    // const checkCartlinesForZeroPricing = (cart: any) => {
    //     if (cart && cart?.cartLines && cart?.cartLines.length) {
    //         const cartLine: any = cart?.cartLines?.find(
    //             (cartItem: any) =>
    //                 cartItem.pricing?.regularPrice == 0 &&
    //                 cartItem.properties?.iskit == "0" &&
    //                 !cartItem.isFixedConfiguration, // to check kit comp
    //         );
    //         if (cartLine) {
    //             return true;
    //         } else {
    //             return false;
    //         }
    //     } else {
    //         return false;
    //     }
    // };

    useEffect(() => {
        if (
            !cartIsLoading &&
            cart &&
            cart.cartLines &&
            cart.cartLines.filter(cl => cl.pricing?.regularPrice == 0).length > 0
        ) {
            setIsAdonisDown(true);
            setIsMessageFlag("message1");
        } else if (
            cartIsLoading &&
            cart &&
            !cart.billToId &&
            !cart.carriers &&
            !cart.cartLines &&
            !cart.paymentOptions &&
            !cart.pickUpDates &&
            !cart.pickUpLocations &&
            !shippingMethods?.deliveryCarrier &&
            !shippingMethods?.deliveryMethod
        ) {
            setIsAdonisDown(true);
            setIsMessageFlag("message2");
        } else if (
            (!cartIsLoading &&
                cart &&
                cart.properties &&
                cart.properties.returnCode81 &&
                cart.properties.returnCode81 !== "00") ||
            (!cartIsLoading &&
                cart &&
                cart.properties &&
                cart?.properties.returnCode80 &&
                cart.properties.returnCode80 !== "00")
        ) {
            setIsAdonisDown(true);
            setIsMessageFlag("message3");
        }
    }, [cart, cartIsLoading]);

    useEffect(() => {
        if (selectedAltAddress) {
            setSelectedAltAddress(selectedAltAddress);
            updateAlternateShip({
                alternateShipTo: selectedAltAddress,
            });
        }
    }, [selectedAltAddress]);

    useEffect(() => {
        // inital load
        if (shipTosDataView?.value && cart) {
            if (!selectedAltAddress) {
                let selectedAltShipTo = shipTosDataView.value.find(s => s.properties["selectasalternate"] === "Y");

                if (!selectedAltShipTo) {
                    selectedAltShipTo = shipTosDataView.value.find(
                        s =>
                            (s.properties.isDropShip && s.properties.isDropShip === "True") ||
                            (s.properties.isdropShip && s.properties.isdropShip === "True"),
                    );
                }
                setSelectedAltAddress(selectedAltShipTo);
            }
            // select first or none if selected was removed
            else {
                let selectedAltShipTo = shipTosDataView.value.find(s => s.id === selectedAltAddress.id);
                if (!selectedAltShipTo) {
                    selectedAltShipTo = shipTosDataView.value.find(
                        s =>
                            (s.properties.isDropShip && s.properties.isDropShip === "True") ||
                            (s.properties.isdropShip && s.properties.isdropShip === "True"),
                    );
                    setSelectedAltAddress(selectedAltShipTo);
                }
            }
        }
    }, [cart, shipTosDataView]);

    useEffect(() => {
        dispatch({ type: "Custom/UpdateDeliveryMethod", result: "primary" });
    }, []);
    useEffect(() => {
        if (isAdonisDown) {
            checkoutmodalpopup();
        }
    }, [isAdonisDown]);

    useEffect(() => {
        if (lineIdToRemove) {
            removeCartLine({
                cartLineId: lineIdToRemove.id,
            });
        }
    }, [lineIdToRemove]);

    useEffect(() => {
        if (lineIdToRemove) {
            const itemExists = cart?.cartLines?.filter(
                (cartLineItem: CartLineModel) => cartLineItem.id === lineIdToRemove.id,
            );
            const cartLineYetToRemove = cart?.cartLines?.filter(
                item => item.properties["cannotShipAir"] === "Y" && item.properties["dgItem"] === "True",
            );
            if (itemExists && itemExists.length == 0 && cartLineYetToRemove && cartLineYetToRemove?.length > 0) {
                removeItem(cartLineYetToRemove[0]);
            } else if (cartLineYetToRemove && cartLineYetToRemove.length == 0) {
                setShowModal(false);
                setLineIdToRemove(undefined);
                if (cart?.cartLines?.length == 0) {
                    redirectToCartPage();
                } else if (shippingSelectionState === "alternate") {
                    updateCartWithSelectedMethod(false, "", "alternate", "", false, selectedAltAddress);
                }
            }
        }
        // code for running tax calculation on adding products on checkout page
        else if (sessionStorage.getItem("item_list_name") == "Checkout Review Page"
            || localStorage.getItem("item_list_name") == "Checkout Review Page") {
            if (shippingSelectionState === "alternate") {
                updateCartWithSelectedMethod(false, "", "alternate", "", false, selectedAltAddress);
            }
            else if (shippingSelectionState === "primary") {
                updateCartWithSelectedMethod(false, "", "primary", "", true);
            }
            sessionStorage.setItem("item_list_name", "");
            localStorage.setItem("item_list_name", "");
        }
        //////////////////
    }, [cart?.cartLines]);

    useEffect(() => {
        if (selectedDeliveryMethodValue && updateDeliveryMethod) {
            if (!cart?.properties.freeShipPromocode || cart?.properties.freeShipPromocode === "") {
                updateCartWithSelectedMethod(false, "shipping", shippingSelectionState, selectedDeliveryMethodValue);
            } else {
                updateCartWithSelectedMethod(true, "freeship", shippingSelectionState, selectedDeliveryMethodValue);
            }
        }
    }, [selectedDeliveryMethodValue, updateDeliveryMethod]);

    const showDGpopup = (initialLoad: boolean = false, selectedShipTo?: ShipToModel) => {
        if (cart && selectedShipTo && !initialLoad) {
            if (isDGAndOverseas(selectedShipTo)) {
                setShowModal(true);
                return true;
            }
        } else if (cart && initialLoad && shipTosDataView) {
            const filteredShipTo = shipTosDataView?.value?.filter(
                s => s.properties["isDropShip"] == "False" && s.uri !== null,
            )[0];
            if (filteredShipTo && isDGAndOverseas(filteredShipTo)) {
                setShowModal(true);
                return true;
            }
        } else {
            return false;
        }
    };

    const choosePreference = () => {
        return (
            cart?.cartLines &&
            (cart?.cartLines?.length > 1 || (cart?.cartLines[0]?.qtyOrdered && cart?.cartLines[0]?.qtyOrdered > 1)) &&
            shippingSelectionState !== "pickup"
        );
    };

    const isDGAndOverseas = (shipTo: ShipToModel) => {
        const cartClone = JSON.parse(JSON.stringify(cart));
        return (
            shipTo &&
            (shipTo.state?.name?.toUpperCase() === "ALASKA" ||
                shipTo.state?.name?.toUpperCase() === "HAWAII" ||
                shipTo.country?.name?.toUpperCase() === "PUERTO RICO") &&
            cartClone?.cartLines?.filter((x: any) => x.properties["cannotShipAir"] === "Y")?.length > 0 &&
            cartClone?.cartLines?.filter((x: any) => x.properties["dgItem"] === "True")?.length > 0
        );
    };

    const redirectToCartPage = () => {
        history.push(cartPageLink);
    };

    const removeItem = (cartLineReceived?: CartLineModel) => {
        const cartLineToRemove: any = cart?.cartLines?.filter(
            item => item.properties["cannotShipAir"] === "Y" && item.properties["dgItem"] === "True",
        )[0];

        const cartClone = JSON.parse(JSON.stringify(cart));
        setLineIdToRemove(cartLineReceived ? cartLineReceived : cartLineToRemove);
    };

    const redirectToQuoteDetails = () => {
        const quoteNumber = sessionStorage.getItem("quoteNumber");
        history.push(`/MyAccount/MyQuotes/Details?quotenumber=${quoteNumber}&suffix=000`);
    };

    const shippingtotalweight = () => {
        let shippingtotalWeights = 0;
        let hasShipLTL = false;
        if (cart && cart.cartLines) {
            hasShipLTL = cart.cartLines.filter(anyProduct => anyProduct.properties["musT_SHP_LTL"] === "Y").length > 0;
            cart?.cartLines?.forEach(cartLine => {
                shippingtotalWeights += cartLine?.qtyOrdered! * parseFloat(cartLine.properties["iteM_WEIGHT"]);
                if (shippingtotalWeights <= 0) {
                    shippingtotalWeights = Number("10");
                }
            });
        }

        return shippingtotalWeights;
    };

    useEffect(() => {
        if (shippingSelectionState === "pickup" && pickUpLocationStates?.length) {
            const defaultItem = pickUpLocationStates?.find(item => item.isDefault);
            const pickupLocationState = pickUpLocationStates[0];
            if (defaultItem) {
                setSelectedState(defaultItem);
            } else {
                setSelectedState(pickupLocationState);
            }
        }
    }, [shippingSelectionState]);

    const handlePickUpInBranchSelection = (cannotShip: boolean = false) => {
        //  if (pickUpLocationStates && pickUpLocationStates.length && !isCartLoading) {
        if (pickUpLocationStates && pickUpLocationStates.length) {
            setUpdateCartLoading({
                loading: true,
            });

            const defaultItem = pickUpLocationStates!.find(item => item.isDefault);
            const fallBackPickupLocation = pickUpLocationStates![0];
            const initialBranch = defaultItem ? defaultItem : fallBackPickupLocation;

            const pickUpDates = cloneDeep(cart!.pickUpDates);
            const adiOffsetTime = negitiveOffsetADITime(initialBranch.timeOffset);
            const before4 = isHourBefore(adiOffsetTime, 16);
            const excludeToday: boolean = !before4;
            const pickUpDatesValue: any = [];
            pickUpDates?.forEach((element: any, i: number) => {
                if (!(i == 0 && excludeToday)) {
                    pickUpDatesValue.push(new Date(element.date));
                }
            });
            setShowShippingOptions(false);
            setdisableADILockerCheckbox(true);
            setIsPickUpSelected(true);

            dispatch({ type: "Custom/UpdateDeliveryMethod", result: "pickup" });
            setShippingSelection("pickup");

            const cartClone = JSON.parse(JSON.stringify(cart));

            // Shipping message changes by Archana in P21 ----- made by smrati //

            cartClone.properties["showShippingExpediteMsg"] = "false";

            /////////////////////////////////////////////////////////////////

            if (cannotShip) {
                setIsRadioDisabled(true);
                setShowModal(false);
                cartClone!.properties["isPickUpInBranch"] = "Y";
            }

            cartClone!.properties["pickUpLocationDc"] = initialBranch?.value || "";
            cartClone!.properties["branchLocationValue"] = initialBranch?.value || "";
            cartClone!.properties["branch"] = initialBranch?.value || "";
            cartClone!.properties["branchLocationText"] = initialBranch?.title || "";
            cartClone!.properties["pickUpDate"] = excludeToday
                ? pickUpDates[2]?.adonisDate
                : pickUpDates[1]?.adonisDate || "";
            cartClone!.properties["requestedOrderDate"] = formattedDate || "";
            cartClone!.properties["adiLockInd"] = adiLockerCheck ? initialBranch?.adiLockInd : "N";
            cartClone!.properties["BranchPickupMaterialTax"] = cartClone!.branchPickupMaterialTax || "";
            cartClone.properties["shippingSelection"] = "pickup";
            cartClone.properties["deliveryMethod"] = initialBranch?.title || "";
            cartClone.properties["deliveryDescription"] = "";
            cartClone.properties["deliveryCarrier"] = "";
            cartClone.properties["freightCost"] = "0.00";
            cartClone!.properties["freightTax"] = `0.00`;
            cartClone!.properties["FreightCharge"] = "0.00";
            cartClone.properties["isPickUp"] = "Y";
            cartClone!.properties["willCallRush"] = "N";
            cartClone.properties["sC_TBD"] = "N";
            if (
                cartClone.properties["custCOD"] == "500" ||
                cartClone.properties["custCOD"] == "881" ||
                cartClone.properties["custCOD"] == "888" ||
                cartClone.properties["custCOD"] == "991" ||
                cartClone.properties["custCOD"] == "999"
            ) {
                cartClone!.properties["CODCustomer"] = "Yes";
                cartClone!.properties["isCODCustomer"] = "Y";
                cartClone!.properties["COD_pickup"] = "Y";
            } else {
                cartClone!.properties["isCODCustomer"] = "NonCod";
                cartClone!.properties["CODCustomer"] = "No";
            }

            // For handle Eco fee item
            cartClone!.properties["branchLocationAbbreviation"] = initialBranch?.abbreviation;
            cartClone!.properties["thirdPartyOnFileId"] = "";

            setIsOneHourPickup(false);
            setIsShowOneHourPickup(false);
            if (cartClone.carriers) {
                const carrier = cartClone?.carriers?.filter(
                    (sv: { description: string }) => sv.description == "Pick-Up in Branch",
                )[0];

                cartClone.carrier = carrier;
                cartClone.shipVia = carrier?.shipVias[0];
                cartClone.shipTo = sessionShipTO.value;
            }

            if (cartClone.carrierCodes) {
                const carrierCode = cartClone?.carrierCodes?.filter((sv: { code: string }) => sv.code == "9001")[0];

                cartClone!.properties["WillCallCarrierCode"] = carrierCode?.code;
            }

            if (cartClone.carrierCodes) {
                const carrierCode = cartClone?.carrierCodes?.filter((sv: { code: string }) => sv.code == "9003")[0];

                cartClone!.properties["PatroomCarrierCode"] = carrierCode?.code;
            }

            let payBill = cartClone.properties["paymentMethod"] === "bill" ? true : false;
            cartClone!.properties["paymentMethod"] = payBill ? "bill" : "CC";
            if (paymentMethod) {
                cartClone!.properties["paymentMethod"] = paymentMethod.toLowerCase();
                payBill = paymentMethod.toLowerCase() === "bill" ? true : false;
            }

            cartClone!.paymentMethod = {
                ...cartClone!.paymentMethod,
                isCreditCard: payBill ? false : true,
                description: payBill ? "Bill" : "Credit Card",
                isPaymentProfile: false,
                name: payBill ? "BILL" : "CC",
            };

            if (isFreeShipPromoApplied(cartClone)) {
                const promotionData = `${cartClone!.properties["freeShipPromocode"]},${cartClone!.properties["shippingSelection"]
                    },,,`;
                const removedPromoCode = cartClone!.properties["freeShipPromocode"];
                applyPromotion({
                    promotionCode: promotionData,
                    onComplete(result: any) {
                        if (result && result?.errorMessage) {
                            setPromotionState({
                                showPromotionErrorMessage: true,
                                promotionErrorMessage: result.apiResult.message,
                                removedPromoCode,
                            });
                        } else {
                            setPromotionState({
                                showPromotionErrorMessage: false,
                            });
                        }
                    },
                });
                cartClone!.properties["remove"] = "freeship";
                cartClone!.properties["returnCode"] = "";
                cartClone!.properties["freeShipPromocode"] = "";
                cartClone!.properties["freeShipDiscountAmountDisplay"] = "";
                cartClone!.properties["freeShipDiscountMessage"] = "";
                cartClone!.properties["FreeShipDiscountAmount"] = "";
            }
            cartClone.showTaxAndShipping = true;
            setSelectedDeliveryMethodValue(undefined);
            cartClone.billTo = billToState.value;
            loadCartSummary({
                cart: { ...cartClone } as unknown as CartModel,
                onSuccess(result: CartSummaryMethodsResults) {
                    cartClone.properties["orderMaterialTax"] = parseFloat(result?.cartSummary?.salesTax);
                    cartClone.properties["freightTax"] = parseFloat(result?.cartSummary?.taxOnFreight);
                    cartClone.properties["BranchPickupMaterialTax"] = parseFloat(result?.cartSummary?.salesTax);
                    setInitialShippingMethodsLoaded(false);
                    const newCart = updateCartCalculationWithNewCart(cartClone, "Pickup");
                    updateCart({
                        cart: newCart,
                        onSuccess(result: ADIUpdateCartResult) {
                            setdisableADILockerCheckbox(false);
                            setIsLoading(false);
                            setUpdateCartLoading({
                                loading: false,
                            });
                            if (isFreeShipPromoApplied(result.cart)) {
                                applyPromotion({ promotionCode: "" });
                            }
                        },
                    });
                },
            });
        }
    };

    const handlePickUpInBranchLocationSelection = (selectedStateVal: PickUpLocation) => {
        setUpdateCartLoading({
            loading: true,
        });

        const pickUpDates = cloneDeep(cart!.pickUpDates);
        const adiOffsetTime = negitiveOffsetADITime(selectedStateVal.timeOffset);
        const before4 = isHourBefore(adiOffsetTime, 16);
        const excludeToday: boolean = !before4;

        const cartClone = JSON.parse(JSON.stringify(cart));
        cartClone!.properties["pickUpLocationDc"] = selectedStateVal?.value || "";
        cartClone!.properties["branchLocationValue"] = selectedStateVal?.value || "";
        cartClone!.properties["branch"] = selectedStateVal?.value || "";
        cartClone!.properties["branchLocationText"] = selectedStateVal?.title || "";
        cartClone!.properties["pickUpDate"] = excludeToday
            ? pickUpDates[2]?.adonisDate
            : pickUpDates[1]?.adonisDate || "";
        cartClone!.properties["requestedOrderDate"] = formattedDate || "";
        cartClone!.properties["adiLockInd"] = "N";
        cartClone!.properties["BranchPickupMaterialTax"] = cartClone!.branchPickupMaterialTax || "";
        cartClone.properties["shippingSelection"] = "pickup";
        cartClone.properties["deliveryMethod"] = selectedStateVal?.title || "";
        cartClone.properties["deliveryDescription"] = "";
        cartClone.properties["deliveryCarrier"] = "";
        cartClone.properties["freightCost"] = "0.00";
        cartClone!.properties["freightTax"] = `0.00`;
        cartClone!.properties["FreightCharge"] = "0.00";
        cartClone.properties["isPickUp"] = "Y";
        cartClone!.properties["willCallRush"] = "N";
        // For handle Eco fee item
        cartClone!.properties["branchLocationAbbreviation"] = selectedStateVal?.abbreviation;
        cartClone.properties["thirdPartyOnFileId"] = "";

        setIsOneHourPickup(false);
        setIsShowOneHourPickup(false);
        if (cartClone.carriers) {
            const carrier = cartClone?.carriers?.filter(
                (sv: { description: string }) => sv.description == "Pick-Up in Branch",
            )[0];

            cartClone.carrier = carrier;
        }

        const payBill = cartClone.properties["paymentMethod"] === "bill" ? true : false;

        cartClone!.properties["paymentMethod"] = payBill ? "bill" : "CC";

        cartClone!.paymentMethod = {
            ...cartClone!.paymentMethod,
            isCreditCard: payBill ? false : true,
            description: payBill ? "Bill" : "Credit Card",
            isPaymentProfile: false,
            name: payBill ? "BILL" : "CC",
        };

        cartClone.billTo = billToState.value;
        loadCartSummary({
            cart: { ...cartClone } as unknown as CartModel,
            onSuccess(result: CartSummaryMethodsResults) {
                cartClone.properties["orderMaterialTax"] = parseFloat(result?.cartSummary?.salesTax);
                cartClone.properties["freightTax"] = parseFloat(result?.cartSummary?.taxOnFreight);
                cartClone.properties["BranchPickupMaterialTax"] = parseFloat(result?.cartSummary?.salesTax);
                const newCart = updateCartCalculationWithNewCart(cartClone, "Pickup");
                setInitialShippingMethodsLoaded(false);
                updateCart({
                    cart: newCart,
                    onSuccess(result: ADIUpdateCartResult) {
                        setIsLoading(false);
                        setUpdateCartLoading({
                            loading: false,
                        });
                    },
                });
            },
        });
    };

    const setSelectedShipingMethod = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const targetValue = event.target.value;
        if (cart && targetValue && targetValue !== "pickup" && shippingSelectionState !== "pickup") {
            setUpdateCartLoading({
                loading: true,
            });
            setUpdateDeliveryMethod(true);
            setSelectedDeliveryMethodValue(targetValue);
            setStoreMoreOptionValue(targetValue);
            //  ADINA-56706- putting this code to a useEffect //
            // if (!cart.properties.freeShipPromocode || cart.properties.freeShipPromocode === "") {
            //     updateCartWithSelectedMethod(false, "", shippingSelectionState, targetValue);
            // } else {
            //     updateCartWithSelectedMethod(true, "freeship", shippingSelectionState, targetValue);
            // }
        }
    };

    const formatDeliveryMethodValue = (method: DeliveryMethod, item: DeliveryCarrier) => {

        const methodData = {
            car: method.car,
            cd: method.cd,
            descr: method.descr,
            def: method.def,
            freightCost: method.freightCost,
            frieghtTax: method.frieghtTax,
            isTBD: method.isTBD,
        };
        if (method.car.trim() == item.cd.trim()) {
            if (item.thirdPartyOnFile.trim() != "") {
                if (method.descr.trim().indexOf(item.desc.trim()) >= 0) {
                    methodData.descr = method.descr.trim();
                } else {
                    methodData.descr = item?.desc.trim() + " - " + method?.descr.trim();
                }
                methodData.freightCost = 0;
            } else if (method.isTBD) {
                methodData.descr = item.desc.trim() + " - " + method.descr.trim() + " - " + "TBD";
            } else {
                let descr =
                    item.desc.trim() +
                    " - " +
                    method.descr.trim() +
                    " - " +
                    (method.freightCost != 0 ? formatAsCurrency(method.freightCost).toString() : 'FREE')
                // formatAsCurrency(method.freightCost).toString();
                if (localStorage.getItem("IsFreeShip")) {
                    let isFreeShip = localStorage.getItem("IsFreeShip");
                    if (
                        isFreeShip == "Yes" &&
                        method.descr.toUpperCase().indexOf("GROUND") >= 0 &&
                        method.freightCost == 0
                    ) {
                        descr = item.desc.trim() + " - " + method.descr.trim() + " - " + "FREE";
                    }
                    if (
                        isFreeShip == "Yes" &&
                        method.descr.toUpperCase().indexOf("STANDARD") >= 0 &&
                        method.freightCost == 0
                    ) {
                        descr = item.desc.trim() + " - " + method.descr.trim() + " - " + "FREE";
                    }
                }
                methodData.descr = descr;
            }
            if (method.cd.trim().indexOf(method.car.trim()) >= 0) {
                methodData.cd = method.cd.trim();
            } else {
                methodData.cd = method.cd.trim() + "|" + method.car.trim();
            }
            return methodData;
        }
    };

    const getLTLBaseFreight = (
        shippingMethodsData: ShippingMethodsResults | null | undefined,
        resultData?: ShippingMethodsResults | null
    ): string | null => {
        const deliveryMethods = shippingMethodsData?.deliveryMethod || resultData?.deliveryMethod;
        const ltlBaseFreight = deliveryMethods?.find(item => item.cd === "9008-0");
        return ltlBaseFreight ? ltlBaseFreight.freightCost.toString() : null;
    };


    const updateCartWithSelectedMethod = async (
        removePromo = false,
        type = "",
        shippingSelection = "primary",
        deliveryMethod = "",
        firstTimeRender = false,
        providedShipTo?: ShipToModel,
    ) => {

        // removing 2 times call to function in case of change delivery method and ship method
        if (!firstTimeRender) {
            setUpdateDeliveryMethod(false);
        }
        // if pickup, redirect to handlePickup methods
        if (shippingSelection === "pickup") {
            setShippingSelection(shippingSelection);
            dispatch({ type: "Custom/UpdateDeliveryMethod", result: "pickup" });
            dispatch({ type: "Custom/UpdatePaymentMethod", result: "showBill" });
            handlePickUpInBranchSelection();
            return;
        }

        dispatch({ type: "Custom/UpdatePaymentMethod", result: "" });
        setAdiLockerCheck(false);
        setShippingSelection(shippingSelection);
        let shippingWeights = 0;
        let hasShipLTL = false;
        let hasBulkItem = false;

        if (cart && cart.cartLines) {
            hasShipLTL = cart.cartLines.filter(anyProduct => anyProduct.properties["musT_SHP_LTL"] === "Y").length > 0;
            hasBulkItem = cart.cartLines.filter(anyProduct => anyProduct.properties["bulk_Item"] === "Y").length > 0;
            cart?.cartLines?.forEach(cartLine => {
                shippingWeights += cartLine?.qtyOrdered! * parseFloat(cartLine.properties["iteM_WEIGHT"]);
                if (shippingWeights <= 0) {
                    shippingWeights = Number("10");
                }
            });
        }
        let branchCode = "";
        if (
            shipToState != null &&
            cart?.properties["branchLocationValue"] != null &&
            cart?.properties["branchLocationValue"] != "" &&
            cart?.properties["shippingSelection"] != undefined &&
            (cart?.properties["shippingSelection"] == "pickup" || cart?.properties["shippingSelection"] == "pickup_mob")
        ) {
            branchCode = cart?.properties["branchLocationValue"];
        }

        let cannotShipAir = "";
        let shipAirNCount = cart?.cartLines?.filter(
            anyProduct => anyProduct.properties["cannotShipAir"] === "N",
        ).length;
        let shipAirYCount = cart?.cartLines?.filter(
            anyProduct => anyProduct.properties["cannotShipAir"] === "Y",
        ).length;
        if (shipAirYCount! > 0) cannotShipAir = "Y";
        else if (shipAirNCount! > 0) cannotShipAir = "N";
        else cannotShipAir = "";

        let checkAddressOne = "";
        let address1 = "";
        let address2 = "";
        let city = "";
        let postalCode = "";
        let state = "";
        if (providedShipTo) {
            checkAddressOne = providedShipTo.address1 || "";
            if (checkAddressOne != "") {
                address1 = checkAddressOne;
                address2 = providedShipTo.address2 || "";
                city = providedShipTo.city || "";
                postalCode = providedShipTo.postalCode || "";
                state = providedShipTo.state?.abbreviation || "";
            }
        } else {
            checkAddressOne =
                shippingSelection === "alternate"
                    ? selectedAltAddress?.address1 || ""
                    : sessionShipTO.value?.address1 || "";
            if (checkAddressOne != "") {
                address1 = checkAddressOne;
                address2 =
                    shippingSelection === "alternate"
                        ? selectedAltAddress?.address2 || ""
                        : sessionShipTO.value?.address2 || "";
                city =
                    shippingSelection === "alternate"
                        ? selectedAltAddress?.city || ""
                        : sessionShipTO.value?.city || "";
                postalCode =
                    shippingSelection === "alternate"
                        ? selectedAltAddress?.postalCode || ""
                        : sessionShipTO.value?.postalCode || "";
                state =
                    shippingSelection === "alternate"
                        ? selectedAltAddress?.state?.abbreviation || ""
                        : sessionShipTO.value?.state?.abbreviation || "";
            }
        }

        if (type == "shipping" || type == "freeship") {
            dispatch({ type: "Custom/UpdateDeliveryMethod", result: shippingSelection });

            let shipToRecord = {} as ShipToModel;

            if (shippingSelection === "alternate" && !providedShipTo) {
                shipToRecord = selectedAltAddress!;
            } else if (shippingSelection === "alternate" && providedShipTo) {
                shipToRecord = providedShipTo;
            } else {
                shipToRecord = shipTosDataView!.value!.filter(
                    s => s.properties["isDropShip"] == "False" && s.uri !== null,
                )[0];
            }

            if (!shipToRecord && sessionShipTO.value && shippingSelection !== "alternate") {
                shipToRecord = cloneDeep(sessionShipTO.value);
            }

            let cartClone = JSON.parse(JSON.stringify(cart!));

            // Shipping message changes by Archana in P21 ----- made by smrati //

            let deliveryOption;
            if (deliveryMethod == "") {
                deliveryOption = cartClone?.carrierCodes.find(
                    (ele: any) => ele.code == cart?.properties["deliveryMethod"],
                );
            } else {
                let methodIndex = parseInt(deliveryMethod.split("_")[1]);
                let deliveryMethodCode = shippingMethods?.deliveryMethod[methodIndex].cd;
                deliveryOption = cartClone?.carrierCodes.find((ele: any) => ele.code == deliveryMethodCode);
            }
            if (
                cartClone?.properties["shippingSelection"] !== "pickup" &&
                cartClone?.properties["thirdPartyOnFileId"] == "" &&
                cartClone?.properties["deliveryCarrier"] != "LT" &&
                deliveryOption.method !== "G"
            ) {
                cartClone.properties["showShippingExpediteMsg"] = "true";
            } else {
                cartClone.properties["showShippingExpediteMsg"] = "false";
            }

            if (shippingSelection !== "pickupinbranch") {
                setIsPickUpSelected(false);
                if (
                    cartClone.properties["custCOD"] == "500" ||
                    cartClone.properties["custCOD"] == "881" ||
                    cartClone.properties["custCOD"] == "888" ||
                    cartClone.properties["custCOD"] == "991" ||
                    cartClone.properties["custCOD"] == "999"
                ) {
                    cartClone!.properties["CODCustomer"] = "Yes";
                    cartClone!.properties["isCODCustomer"] = "N";
                    cartClone!.properties["COD_pickup"] = "N";
                } else {
                    cartClone!.properties["isCODCustomer"] = "NonCod";
                    cartClone!.properties["CODCustomer"] = "No";
                    // ADINA-51809
                    const payBill = cart!.properties?.paymentMethod
                        ? cart!.properties?.paymentMethod.toLowerCase() === "bill"
                            ? true
                            : false
                        : true;

                    cartClone!.properties["paymentMethod"] = payBill ? "bill" : "CC";
                    cartClone!.paymentMethod = {
                        ...cartClone!.paymentMethod,
                        isCreditCard: payBill ? false : true,
                        description: payBill ? "Bill" : "Credit Card",
                        isPaymentProfile: false,
                        name: payBill ? "BILL" : "CC",
                    };
                    // ADINA-51809
                }

                const hasDefaultYes = shippingMethods?.deliveryMethod?.find(item => item.def === "Y")?.descr.trim();
                const indexOfItem = shippingMethods?.deliveryMethod?.findIndex(item => item.def === "Y");
                if (hasDefaultYes && deliveryMethod === "" && firstTimeRender) {
                    deliveryMethod = hasDefaultYes + `_${indexOfItem}`;
                }

                let ltlBaseFreight = shippingMethods?.deliveryMethod?.find(item => item.cd === "9008-0");
                if (ltlBaseFreight != null) {
                    cartClone!.properties["ltlStandardFreight"] = ltlBaseFreight.freightCost.toString();
                }

                let selectedOption: DeliveryMethod | undefined = undefined;
                //let selectedOption: DeliveryMethod | undefined = undefined;

                if (!selectedDeliveryMethodValue || firstTimeRender) {
                    if (indexOfItem) selectedOption = shippingMethods?.deliveryMethod[indexOfItem];
                } else if (deliveryMethod !== "") {
                    selectedOption = shippingMethods?.deliveryMethod.find(
                        (item, index) => item.descr.trim() + `_${index}` === deliveryMethod.trim(),
                    );
                }

                if (!selectedOption && shippingMethods?.deliveryMethod[0]) {
                    selectedOption = shippingMethods.deliveryMethod[0];
                    deliveryMethod = shippingMethods.deliveryMethod[0].descr.trim() + `_0`;
                }

                const carrier = cartClone?.carriers?.filter(
                    (sv: { description: string }) => sv.description == "Ship",
                )[0];

                let selectedOptions: any = getUpdatedDeliveryMethod(selectedOption, shippingMethods);


                if (selectedOptions) {
                    for (let i = 0; i < selectedOptions?.length; i++) {
                        if (selectedOptions[i] != undefined) {
                            selectedOptions = selectedOptions[i];
                            break;
                        }
                    }

                    setSelectedDeliveryMethodDisplay(selectedOptions);

                    if (firstTimeRender) {
                        setSelectedDeliveryMethodValue(deliveryMethod);
                    } else if (deliveryMethod !== "") {
                        setSelectedDeliveryMethodValue(deliveryMethod);
                    } else if (!hasShipLTL && !selectedOptions[0]) {
                        setSelectedDeliveryMethodValue(shippingMethods?.deliveryMethod[0].descr.trim() + `_${0}`);
                    }
                }

                // // Note for Devs: If the current cart has a primary ship to already assigned and the shipping calculations line up with the shipping methods api,
                // // then we don't need to PATCH-GET a new Cart. This is a performance gain on initial page load. There may need to be other conditions added to this.
                // if (
                //     renderFirstTimeOnly &&
                //     selectedOption &&
                //     selectedOption.car !== "LT" &&
                //     cart?.properties.freightCost &&
                //     cart.properties.freightCost.trim().length > 0 &&
                //     !removePromo &&
                //     cart?.properties["shippingSelection"] === "primary" &&
                //     shippingSelection !== "alternate" &&
                //     parseInt(cart.properties.freightCost.trim()) === selectedOption.freightCost &&
                //     cart.type.toLowerCase() !== "quote"
                // ) {
                //     setUpdateCartLoading({
                //         loading: false,
                //     });
                //     setInitialShippingMethodsLoaded(false);
                //     return;
                // } else
                if (
                    cart?.type.toLowerCase() === "quote" &&
                    (!cartClone.properties["shipPartial"] || cartClone.properties["shipPartial"] === "") &&
                    renderFirstTimeOnly
                ) {
                    cartClone.properties["shipPartial"] = "true";
                }

                if (selectedOptions && !selectedOptions.isTBD) {
                    cartClone.showTaxAndShipping = true;
                } else if (selectedOptions && selectedOptions.isTBD) {
                    cartClone.showTaxAndShipping = false;
                }

                if (cart?.type.toLowerCase() === "quote" && !renderFirstTimeOnly && shippingSelection === "alternate") {
                    cartClone!.properties["isQuoteAlternateSelectAddress"] = "Y";
                }

                setShowShippingOptions(false);
                if (removePromo) {
                    //freeShipPromocode
                    if (type === "freeship") {
                        cartClone!.properties["remove"] = "freeship";
                        cartClone!.properties["returnCode"] = "";
                        cartClone!.properties["freeShipPromocode"] = "";
                        cartClone!.properties["freeShipDiscountAmountDisplay"] = "";
                        cartClone!.properties["freeShipDiscountMessage"] = "";
                        cartClone!.properties["FreeShipDiscountAmount"] = "";
                    }
                }
                cartClone!.properties["pickUpDate"] = "";
                cartClone!.properties["requestedOrderDate"] = formattedDate || "";
                cartClone!.properties["deliveryCarrier"] = `${selectedOption?.car.trim() || ""}`;
                cartClone!.properties["deliveryMethod"] = `${selectedOption?.cd.trim() || ""}`;

                let eleIndex = shippingMethods?.deliveryCarrier.findIndex(ele => ele.cd == cartClone!.properties["deliveryCarrier"]);
                if (eleIndex !== undefined && eleIndex !== -1) {
                    cartClone!.properties["deliveryDescription"] = `${shippingMethods?.deliveryCarrier[eleIndex]?.desc.trim()} - ${selectedOption?.descr.trim() || ""}`;
                }
                else {
                    cartClone!.properties["deliveryDescription"] = `${shippingMethods?.deliveryCarrier[0]?.desc.trim()} - ${selectedOption?.descr.trim() || ""}`;
                }
                 
                 if(selectedOption != null && selectedOption != undefined)
                        {
                cartClone!.properties["freightCost"] = ` ${selectedOption?.freightCost}`;
                cartClone!.properties["freightTax"] = `${selectedOption?.frieghtTax}`;
                        }
                    else {
                cartClone!.properties["freightCost"] = `0.00`;
                cartClone!.properties["freightTax"] = `0.00`;
                        }
                cartClone!.properties["paymentMethod"] = "bill";
                cartClone!.properties["branchLocationValue"] = "";
                cartClone!.properties["pickUpLocationDc"] =
                    pickUpLocationStates?.find(item => item.isDefault)?.value.toString() || "";
                cartClone!.properties["branch"] = "";
                cartClone!.properties["branchLocationText"] = "";
                cartClone!.properties["BranchPickupMaterialTax"] = "";
                cartClone!.properties["isPickUp"] = "N";
                cartClone!.properties["adiLockInd"] = "N";
                cartClone!.properties["willCallRush"] = "N";
                cartClone!.properties["sC_TBD"] = selectedOption?.isTBD ? "Y" : "N";
                cartClone!.properties["thirdPartyOnFile"] = selectedOption?.descr.trim() !== "TBD" ? "0" : "1";
                cartClone.properties["shippingSelection"] = shippingSelection;
                let thirdPartyObject = cartClone?.carrierCodes.filter((ele: any) => {
                    if (ele?.code == selectedOption?.cd) return ele;
                });
                if (
                    thirdPartyObject != null &&
                    thirdPartyObject.length > 0 &&
                    thirdPartyObject[0].carr3POnFile != null
                ) {
                    cartClone.properties["thirdPartyOnFileId"] = thirdPartyObject[0].carr3POnFile;
                }
                cartClone.carrier = carrier;

                const payBill = cartClone.properties["paymentMethod"] === "bill" ? true : false;

                cartClone!.properties["paymentMethod"] = payBill ? "bill" : "CC";

                cartClone!.paymentMethod = {
                    ...cartClone!.paymentMethod,
                    isCreditCard: payBill ? false : true,
                    description: payBill ? "Bill" : "Credit Card",
                    isPaymentProfile: false,
                    name: payBill ? "BILL" : "CC",
                };
                // updateCartCalculationWithNewCart(cartClone);

                if (cartClone.carriers) {
                    const carrier = cartClone?.carriers?.filter(
                        (sv: { description: string }) => sv.description == "Ship",
                    )[0];
                    cartClone.shipVia = carrier?.shipVias[0];
                }
                if (deliveryOption)
                    cartClone!.properties["deliveryOption"] = deliveryOption?.method;

                const hasDGOverseas = showDGpopup(false, shipToRecord);
                cartClone.billTo = billToState.value;

                if (!hasDGOverseas) {
                    if (!selectedOption?.isTBD) {
                        loadCartSummary({
                            cart: { ...cartClone } as unknown as CartModel,
                            onSuccess(result: CartSummaryMethodsResults) {

                                cartClone.properties["orderMaterialTax"] = parseFloat(result?.cartSummary?.salesTax);
                                cartClone.properties["freightTax"] = parseFloat(result?.cartSummary?.taxOnFreight);

                                const newCart = updateCartCalculationWithNewCart(cartClone, "Ship");
                                updateCart({
                                    cart: {
                                        ...newCart,
                                        shipToId: shipToRecord.id,
                                    },
                                    onSuccess(result: ADIUpdateCartResult) {

                                        setInitialShippingMethodsLoaded(false);
                                        if (type === "freeship" && removePromo) {
                                            applyPromotion({ promotionCode: "" });
                                        }
                                        setUpdateCartLoading({
                                            loading: false,
                                        });
                                    },
                                });
                            },
                        });
                    } else {
                        const newCart = updateCartCalculationWithNewCart(cartClone, "Ship");
                        updateCart({
                            cart: {
                                ...newCart,
                                shipToId: shipToRecord.id,
                            },
                            onSuccess(result: ADIUpdateCartResult) {

                                setUpdateCartLoading({
                                    loading: false,
                                });
                                setInitialShippingMethodsLoaded(false);
                                if (type === "freeship" && removePromo) {
                                    applyPromotion({ promotionCode: "" });
                                }
                            },
                        });
                    }
                } else {
                    setUpdateCartLoading({
                        loading: false,
                    });
                }
                if (cartClone.properties["orderMaterialTax"] && cartClone.properties["orderMaterialTax"] != undefined) {
                    updateCartCalculationWithNewCart(cartClone, "Ship");
                }
            }
        }

        if (checkAddressOne != "" && type != "shipping" && type != "freeship") {
            if (firstTimeRender != true) {
                setUpdateCartLoading({
                    loading: true
                });
            }
            setCannotShipAirs(cannotShipAir)
            setSelectCity(city);
            setSelectState(state);
            setSelectPostalCode(postalCode);
            setSelectHasBulkItem(hasBulkItem);
            setSelectHasShipLTL(hasShipLTL)
            setSelectShippingWeights(shippingWeights)

            loadShippingMethods({
                apiparameter: {
                    accountLTLAllowed: cart?.accountLTLAllowed,
                    branchID: cart?.p21BranchCode,
                    cannotShipAir: cannotShipAir,
                    carrierCodes: cart?.carrierCodes,
                    destinationCity: city,
                    destinationCountry:
                        shippingSelection === "alternate"
                            ? selectedAltAddress?.country?.abbreviation || ""
                            : shipToState.value?.country?.abbreviation || "",
                    destinationState: state,
                    destinationZipCode: postalCode,
                    freightOptions: cart?.freightOptions,
                    hasBulkItem: hasBulkItem,
                    mustShipLTL: hasShipLTL,
                    orderTotal: cart?.orderGrandTotal || 0,
                    orderWeight: shippingWeights,
                    overrideOriginCity: cart?.overrideOriginCity,
                    overrideOriginCountry: cart?.overrideOriginCountry,
                    overrideOriginState: cart?.overrideOriginState,
                    overrideOriginZipCode: cart?.overrideOriginZipCode,
                    overrideShipperID: cart?.overrideShipperID,
                    defaultCarrierCd: cart?.defaultCarrier,
                    getAllCarriers: false,
                },
                onSuccess(result: ShippingMethodsResults) {
                    dispatch({ type: "Custom/UpdateDeliveryMethod", result: shippingSelection });
                    let shipToRecord = {} as ShipToModel;

                    if (shippingSelection === "alternate" && !providedShipTo) {
                        shipToRecord = selectedAltAddress!;
                    } else if (shippingSelection === "alternate" && providedShipTo) {
                        shipToRecord = providedShipTo;
                    } else {
                        shipToRecord = shipTosDataView!.value!.filter(
                            s => s.properties["isDropShip"] == "False" && s.uri !== null,
                        )[0];
                    }

                    if (!shipToRecord && sessionShipTO.value && shippingSelection !== "alternate") {
                        shipToRecord = cloneDeep(sessionShipTO.value);
                    }

                    let cartClone = JSON.parse(JSON.stringify(cart!));


                    // Shipping message changes by Archana in P21 ----- made by smrati //
                    let deliveryOption;
                    if (deliveryMethod == "") {
                        deliveryOption = cartClone?.carrierCodes.find(
                            (ele: any) => ele.code == cart?.properties["deliveryMethod"],
                        );
                    } else {
                        let methodIndex = parseInt(deliveryMethod.split("_")[1]);
                        let deliveryMethodCode = shippingMethods?.deliveryMethod[methodIndex].cd;
                        deliveryOption = cartClone?.carrierCodes.find((ele: any) => ele.code == deliveryMethodCode);
                    }
                    if (
                        cartClone?.properties["shippingSelection"] !== "pickup" &&
                        cartClone?.properties["thirdPartyOnFileId"] == "" &&
                        cartClone?.properties["deliveryCarrier"] != "LT" &&
                        deliveryOption.method !== "G"
                    ) {
                        cartClone.properties["showShippingExpediteMsg"] = "true";
                    } else {
                        cartClone.properties["showShippingExpediteMsg"] = "false";
                    }
                    // For Fixing shipTo object in case of alternate address selection
                    if (shipToRecord) {
                        cartClone.shipTo = shipToRecord;
                        cartClone.shipToId = shipToRecord?.id;
                    }

                    if (shippingSelection !== "pickupinbranch") {
                        setIsPickUpSelected(false);
                        if (
                            cartClone.properties["custCOD"] == "500" ||
                            cartClone.properties["custCOD"] == "881" ||
                            cartClone.properties["custCOD"] == "888" ||
                            cartClone.properties["custCOD"] == "991" ||
                            cartClone.properties["custCOD"] == "999"
                        ) {
                            cartClone!.properties["CODCustomer"] = "Yes";
                            cartClone!.properties["isCODCustomer"] = "N";
                            cartClone!.properties["COD_pickup"] = "N";
                        } else {
                            cartClone!.properties["isCODCustomer"] = "NonCod";
                            cartClone!.properties["CODCustomer"] = "No";
                            // ADINA-51809
                            const payBill = cart!.properties?.paymentMethod
                                ? cart!.properties?.paymentMethod.toLowerCase() === "bill"
                                    ? true
                                    : false
                                : true;

                            cartClone!.properties["paymentMethod"] = payBill ? "bill" : "CC";
                            cartClone!.paymentMethod = {
                                ...cartClone!.paymentMethod,
                                isCreditCard: payBill ? false : true,
                                description: payBill ? "Bill" : "Credit Card",
                                isPaymentProfile: false,
                                name: payBill ? "BILL" : "CC",
                            };
                            // ADINA-51809
                        }

                        const hasDefaultYes = result?.deliveryMethod?.find(item => item.def === "Y")?.descr.trim();
                        const indexOfItem = result?.deliveryMethod?.findIndex(item => item.def === "Y");

                        if (hasDefaultYes && deliveryMethod === "" && firstTimeRender) {
                            deliveryMethod = hasDefaultYes + `_${indexOfItem}`;
                        }

                        const ltlBaseFreightValue = getLTLBaseFreight(shippingMethods, result);
                        if (ltlBaseFreightValue) {
                            cartClone!.properties["ltlStandardFreight"] = ltlBaseFreightValue;
                        }

                        let selectedOption: DeliveryMethod | undefined = undefined;

                        if (!selectedDeliveryMethodValue || firstTimeRender) {
                            selectedOption = result.deliveryMethod[indexOfItem];
                        } else if (deliveryMethod !== "") {
                            selectedOption = result.deliveryMethod.find(
                                (item, index) => item.descr.trim() + `_${index}` === deliveryMethod.trim(),
                            );
                        }

                        if (!selectedOption && result.deliveryMethod[indexOfItem]) {
                            selectedOption = result.deliveryMethod[indexOfItem];
                            deliveryMethod = hasDefaultYes + `_${indexOfItem}`;
                        }

                        const carrier = cartClone?.carriers?.filter(
                            (sv: { description: string }) => sv.description == "Ship",
                        )[0];

                        let selectedOptions: any = getUpdatedDeliveryMethod(selectedOption, result);


                        if (selectedOptions) {
                            for (let i = 0; i < selectedOptions?.length; i++) {
                                if (selectedOptions[i] != undefined) {
                                    selectedOptions = selectedOptions[i];
                                    break;
                                }
                            }

                            setSelectedDeliveryMethodDisplay(selectedOptions);

                            if (firstTimeRender) {
                                setSelectedDeliveryMethodValue(deliveryMethod);
                            } else if (deliveryMethod !== "") {
                                setSelectedDeliveryMethodValue(deliveryMethod);
                            } else if (!hasShipLTL && !selectedOptions[0]) {
                                setSelectedDeliveryMethodValue(result.deliveryMethod[0].descr.trim() + `_${0}`);
                            }
                        }

                        // Note for Devs: If the current cart has a primary ship to already assigned and the shipping calculations line up with the shipping methods api,
                        // then we don't need to PATCH-GET a new Cart. This is a performance gain on initial page load. There may need to be other conditions added to this.
                        // if (
                        //     renderFirstTimeOnly &&
                        //     selectedOption &&
                        //     selectedOption.car !== "LT" &&
                        //     cart?.properties.freightCost &&
                        //     cart.properties.freightCost.trim().length > 0 &&
                        //     !removePromo &&
                        //     cart?.properties["shippingSelection"] === "primary" &&
                        //     shippingSelection !== "alternate" &&
                        //     parseInt(cart.properties.freightCost.trim()) === selectedOption.freightCost &&
                        //     cart.type.toLowerCase().trim() !== "quote"
                        // ) {
                        //     setUpdateCartLoading({
                        //         loading: false,
                        //     });
                        //     setInitialShippingMethodsLoaded(false);
                        //     return;
                        // } else
                        if (
                            cart?.type?.toLowerCase()?.trim() === "quote" &&
                            (!cartClone.properties["shipPartial"] || cartClone.properties["shipPartial"] === "") &&
                            renderFirstTimeOnly
                        ) {
                            cartClone.properties["shipPartial"] = "true";
                        }

                        if (selectedOptions && !selectedOptions.isTBD) {
                            cartClone.showTaxAndShipping = true;
                        } else if (selectedOptions && selectedOptions.isTBD) {
                            cartClone.showTaxAndShipping = false;
                        }

                        if (
                            cart?.type?.toLowerCase()?.trim() === "quote" &&
                            !renderFirstTimeOnly &&
                            shippingSelection === "alternate"
                        ) {
                            cartClone!.properties["isQuoteAlternateSelectAddress"] = "Y";
                        }

                        setShowShippingOptions(false);
                        if (removePromo || firstTimeRender === true) {
                            //freeShipPromocode
                            if (type === "freeship") {
                                cartClone!.properties["remove"] = "freeship";
                                cartClone!.properties["returnCode"] = "";
                                cartClone!.properties["freeShipPromocode"] = "";
                                cartClone!.properties["freeShipDiscountAmountDisplay"] = "";
                                cartClone!.properties["freeShipDiscountMessage"] = "";
                                cartClone!.properties["FreeShipDiscountAmount"] = "";
                            }
                            if (type === "product") {
                                cartClone!.properties["remove"] = "product";
                                cartClone!.properties["customerPromocode"] = "";
                                cartClone!.properties["customDiscountAmountDisplay"] = "";
                                cartClone!.properties["customDiscountMessage"] = "";
                                cartClone!.properties["customDiscountGrandTotal"] = "";
                                cartClone!.properties["customDiscountAmount"] = "";
                                cartClone!.properties["freeItem"] = "";
                                cartClone!.properties["freeItemDescription"] = "";
                                cartClone!.properties["freeQuantity"] = "";
                                cartClone!.properties["freeItemImageUrl"] = "";
                                cartClone!.properties["freeItemTotal"] = "";
                                cartClone!.properties["salePriceItems"] = "";
                                cartClone!.properties["childCouponDiscnt"] = "";
                                cartClone!.properties["parentSaleItemPrice"] = "";
                                cartClone!.properties["parentChildList"] = "";
                                cartClone!.properties["parentPromoInd"] = "";
                                cartClone!.properties["parordSeq"] = "";
                                cartClone!.cartLines!.forEach((cartLine: any) => {
                                    cartLine.properties["parentChildPromoCode"] = "";
                                    cartLine.properties["parentChildPromoDiscnt"] = "";
                                });
                            }
                            //adding the condition to clear all previous promos when page first loads
                            if (type === "removeAll" || firstTimeRender === true) {
                                cartClone!.properties["returnCode"] = "";
                                cartClone!.properties["freeShipPromocode"] = "";
                                cartClone!.properties["freeShipDiscountAmountDisplay"] = "";
                                cartClone!.properties["freeShipDiscountMessage"] = "";
                                cartClone!.properties["FreeShipDiscountAmount"] = "";
                                cartClone!.properties["remove"] = "product";
                                cartClone!.properties["customerPromocode"] = "";
                                cartClone!.properties["customDiscountAmountDisplay"] = "";
                                cartClone!.properties["customDiscountMessage"] = "";
                                cartClone!.properties["customDiscountGrandTotal"] = "";
                                cartClone!.properties["customDiscountAmount"] = "";
                                cartClone!.properties["freeItem"] = "";
                                cartClone!.properties["freeItemDescription"] = "";
                                cartClone!.properties["freeQuantity"] = "";
                                cartClone!.properties["freeItemImageUrl"] = "";
                                cartClone!.properties["freeItemTotal"] = "";
                                cartClone!.properties["salePriceItems"] = "";
                                cartClone!.properties["childCouponDiscnt"] = "";
                                cartClone!.properties["parentSaleItemPrice"] = "";
                                cartClone!.properties["parentChildList"] = "";
                                cartClone!.properties["parentPromoInd"] = "";
                                cartClone!.properties["parordSeq"] = "";
                                cartClone!.cartLines!.forEach((cartLine: any) => {
                                    cartLine.properties["parentChildPromoCode"] = "";
                                    cartLine.properties["parentChildPromoDiscnt"] = "";
                                });
                            }
                        }
                        cartClone!.properties["pickUpDate"] = "";
                        cartClone!.properties["requestedOrderDate"] = formattedDate || "";
                        cartClone!.properties["deliveryCarrier"] = `${selectedOption?.car.trim() || ""}`;
                        cartClone!.properties["deliveryMethod"] = `${selectedOption?.cd.trim() || ""}`;
                        // changes for delivery method on confirmation page ( to handle undefined)
                        if (shippingMethods !== null && shippingMethods !== undefined) {
                            let eleIndex = shippingMethods?.deliveryCarrier.findIndex(ele => ele.cd == cartClone!.properties["deliveryCarrier"]);
                            if (eleIndex !== undefined && eleIndex !== -1)
                                cartClone!.properties["deliveryDescription"] = `${shippingMethods?.deliveryCarrier[eleIndex]?.desc.trim()} - ${selectedOption?.descr.trim() || ""}`;
                            else
                                cartClone!.properties["deliveryDescription"] = `${shippingMethods?.deliveryCarrier[0]?.desc.trim()} - ${selectedOption?.descr.trim() || ""}`;
                        }
                        else if (result !== null && result !== undefined)
                            cartClone!.properties["deliveryDescription"] = `${result?.deliveryCarrier[0]?.desc.trim()} - ${selectedOption?.descr.trim() || ""}`;
                        else
                            cartClone!.properties["deliveryDescription"] = `${selectedOption?.descr.trim() || ""}`;
                        ///////////////////////////////
                        if(selectedOption != null && selectedOption != undefined)
                        {
                        cartClone!.properties["freightCost"] = ` ${selectedOption?.freightCost}`;
                        cartClone!.properties["freightTax"] = `${selectedOption?.frieghtTax}`;
                        }
                        else
                        {
                        cartClone!.properties["freightCost"] = `0.00`;
                        cartClone!.properties["freightTax"] = `0.00`;
                        }
                        cartClone!.properties["paymentMethod"] = "bill";
                        cartClone!.properties["branchLocationValue"] = "";
                        cartClone!.properties["pickUpLocationDc"] =
                            pickUpLocationStates?.find(item => item.isDefault)?.value.toString() || "";
                        cartClone!.properties["branch"] = "";
                        cartClone!.properties["branchLocationText"] = "";
                        cartClone!.properties["BranchPickupMaterialTax"] = "";
                        cartClone!.properties["isPickUp"] = "N";
                        cartClone!.properties["adiLockInd"] = "N";
                        cartClone!.properties["willCallRush"] = "N";
                        cartClone!.properties["sC_TBD"] = selectedOption?.isTBD ? "Y" : "N";
                        cartClone!.properties["thirdPartyOnFile"] = selectedOption?.descr.trim() !== "TBD" ? "0" : "1";
                        cartClone.properties["shippingSelection"] = shippingSelection;
                        let thirdPartyObject = cartClone?.carrierCodes.filter((ele: any) => {
                            if (ele?.code == selectedOption?.cd) return ele;
                        });
                        if (
                            thirdPartyObject != null &&
                            thirdPartyObject.length > 0 &&
                            thirdPartyObject[0].carr3POnFile != null
                        ) {
                            cartClone.properties["thirdPartyOnFileId"] = thirdPartyObject[0].carr3POnFile;
                        }

                        cartClone.carrier = carrier;

                        const payBill = cartClone.properties["paymentMethod"] === "bill" ? true : false;

                        cartClone!.properties["paymentMethod"] = payBill ? "bill" : "CC";

                        cartClone!.paymentMethod = {
                            ...cartClone!.paymentMethod,
                            isCreditCard: payBill ? false : true,
                            description: payBill ? "Bill" : "Credit Card",
                            isPaymentProfile: false,
                            name: payBill ? "BILL" : "CC",
                        };

                        if (cartClone.carriers) {
                            const carrier = cartClone?.carriers?.filter(
                                (sv: { description: string }) => sv.description == "Ship",
                            )[0];
                            cartClone.shipVia = carrier?.shipVias[0];
                        }
                        if (deliveryOption)
                            cartClone.properties["deliveryOption"] = deliveryOption?.method;

                        const hasDGOverseas = showDGpopup(false, shipToRecord);
                        cartClone.billTo = billToState.value;

                        const isTBDTrue = selectedOptions?.isTBD;

                        if (!hasDGOverseas && !isTBDTrue) {
                            loadCartSummary({
                                cart: { ...cartClone } as unknown as CartModel,
                                onSuccess(result: CartSummaryMethodsResults) {
                                    cartClone.properties["orderMaterialTax"] = parseFloat(
                                        result?.cartSummary?.salesTax,
                                    );
                                    cartClone.properties["freightTax"] = parseFloat(result?.cartSummary?.taxOnFreight);

                                    const newCart = updateCartCalculationWithNewCart(cartClone, "Ship");
                                    updateCart({
                                        cart: {
                                            ...newCart,
                                            shipToId: shipToRecord.id,
                                        },
                                        onSuccess(result: ADIUpdateCartResult) {
                                            setInitialShippingMethodsLoaded(false);
                                            if (type === "freeship" && removePromo) {
                                                applyPromotion({ promotionCode: "" });
                                            }
                                            setUpdateCartLoading({
                                                loading: false,
                                            });
                                        },
                                    });
                                    // }
                                },
                            });
                        }
                        if (isTBDTrue) {
                            const newCart = updateCartCalculationWithNewCart(cartClone, "Ship");
                            updateCart({
                                cart: {
                                    ...newCart,
                                    shipToId: shipToRecord.id,
                                },
                                onSuccess(result: ADIUpdateCartResult) {

                                    setInitialShippingMethodsLoaded(false);
                                    if (type === "freeship" && removePromo) {
                                        applyPromotion({ promotionCode: "" });
                                    }
                                    setUpdateCartLoading({
                                        loading: false,
                                    });
                                },
                            });


                        }

                    }
                },
            });

        }
    };

    const editAddressModalCloseHandler = () => {
        setIsEditAddressModalOpen(false);
    };

    const editAddressFormSubmitHandler = (_: React.FormEvent<HTMLFormElement>, address: ShipToModel) => {
        setUpdateCartLoading({
            loading: true,
        });
        setStoreMoreOptionValue("");
        updateShipTo({
            billToId: billToId!,
            shipTo: address,
            isEdit: true,
            properties: {
                notLoadSession: true,
                skipUpdateCart: true,
            },
            onSuccess() {
                updateCartWithSelectedMethod(false, "", "alternate", selectedDeliveryMethodValue, false, address);
            },
        } as {
            billToId: string;
            shipTo: ShipToModel;
            isEdit: boolean;
            properties: any;
        } & HasOnSuccess<boolean>);
        setSelectedAltAddress(address);
        editAddressModalCloseHandler();
        toasterContext.addToast({
            messageType: "success",
            body: "Address updated.",
        });
    };

    useEffect(() => {
        if (cart && cart.shipPartial && shippingType === "") {
            setShippingType(cart.shipPartial ? "partialText" : "completeText");
        }
    }, [cart]);

    useEffect(() => {
        if (cart && shipTosDataView && !shipTosDataView.value && !shipTosDataView.isLoading) {
            loadShipTos({
                billToId: cart.billToId,
                expand: ["validation"],
                exclude: ["showAll", "billTo", "oneTime", "createNew"],
            });
            setInitialShipTosLoaded(true);
        }

        if (cart && shipTosDataView && shipTosDataView.value && !shipTosDataView.isLoading && renderFirstTimeOnly) {
            setRenderFirstTimeOnly(false);
            setInitialShippingMethodsLoaded(false);
            // Start: Is Drop Ship 0 condition for new alternate addresss
            setUpdateCartLoading({
                loading: true,
            });

            if ((cart.type.toLowerCase()).trim() === "quote") {
                const isP21AddressSameAsPrimary = compareAddress(sessionShipTO.value, cart.properties);
                const existingshipTo = shipTosDataView?.value?.filter(function (s) {
                    return (
                        s.companyName.trim().toUpperCase() === cart.properties.newSTCompnayName.trim().toUpperCase() &&
                        s.address1.trim().toUpperCase() === cart.properties.newSTAddress1.trim().toUpperCase() &&
                        s.address2.trim().toUpperCase() === cart.properties.newSTAddress2.trim().toUpperCase() &&
                        s.city.trim().toUpperCase() === cart.properties.newSTCity.trim().toUpperCase() &&
                        s.postalCode.trim().toUpperCase() === cart.properties.newSTPostal.trim().toUpperCase()
                    );
                });

                if (!existingshipTo || existingshipTo.length === 0) {
                    var altAddress: any = cloneDeep(newAddress);
                    var countryState: any =
                        countries![0].states!.find(s => s.abbreviation === cart.properties.newSTState) || null;
                    if (!countryState) {
                        countryState = {
                            id: "00000000-0000-0000-0000-000000000000",
                            name: "NonProvincesStates",
                            abbreviation: cart.properties.newSTState,
                        };
                    }
                    altAddress = {
                        id: "Create New",
                        address1: cart.properties.newSTAddress1,
                        address2: cart.properties.newSTAddress2,
                        city: cart.properties.newSTCity,
                        postalCode: cart.properties.newSTPostal,
                        state: countryState,
                        country: countries![0],
                        companyName: cart.properties.newSTCompnayName,
                        firstName: "",
                        lastName: "",
                        isNew: true,
                        properties: {
                            nickname: "",
                            selectasalternate: "Y",
                            removeinfuture: "Y",
                            newQuoteAddress: "Y",
                            dropship: "0",
                        },
                    };

                    changeShippingAddressHandler(altAddress as ShipToModel);
                } else if (!isP21AddressSameAsPrimary) {
                    setSelectedAltAddress(existingshipTo[0]);
                    updateCartWithSelectedMethod(false, "", "alternate", "", true, existingshipTo[0]);
                } else {
                    updateCartWithSelectedMethod(false, "", "primary", "", true);
                }
            }
            else if (cart?.freightOptions !== null && cart?.carrierCodes !== null) {
                updateCartWithSelectedMethod(false, "", "primary", "", true);
            }
            //End: Is Drop Ship to

            setRenderFirstTimeOnly(false);
            showDGpopup(true);
        }
    }, [cart, shipTosDataView]);

    useEffect(() => {
        if (!shipToState.value && !shipToState.isLoading && cart) {
            loadShipTo({ billToId: cart.billToId!, shipToId: cart.shipToId! });
        }
        setInitialShippingMethodsLoaded(false);
    }, [shipToState]);

    if (!countries || !shipToState.value || !billToState.value || !cart) {
        return null;
    }

    const { billToId } = cart;

    const adiLockerHandler = (isAdiLocker: boolean, selectedStateVal: PickUpLocation = selectedState!) => {
        if (isAdiLocker) {
            setIsAdiLockerModalOpen(true);
            setIsOneHourPickup(false); // uncheck one hour pickup
        }

        setAdiLockerCheck(isAdiLocker);

        if (cart) {
            let cartClone = JSON.parse(JSON.stringify(localCart));

            cartClone!.properties.isPickUpAdiLocker = isAdiLocker ? "true" : "false";
            cartClone!.properties["willCallRush"] = isAdiLocker ? "N" : cartClone!.properties["willCallRush"];
            cartClone!.properties["adiLockInd"] = isAdiLocker ? "Y" : "N";

            if (isAdiLocker && isCodCustomer(cartClone)) {
                dispatch({ type: "Custom/UpdatePaymentMethod", result: "hideBill" });
                dispatch({ type: "Custom/UpdateOneHourPickup", result: "" });
                cartClone!.properties["paymentMethod"] = "CC";
            } else if (isCodCustomer(cartClone)) {
                cartClone!.properties["paymentMethod"] = "Bill";
                dispatch({ type: "Custom/UpdatePaymentMethod", result: "showBill" });
            }

            cartClone!.properties["pickUpLocationDc"] = selectedStateVal?.value || "";
            cartClone!.properties["branchLocationValue"] = selectedStateVal?.value || "";
            cartClone!.properties["branchLocationText"] = selectedStateVal?.title || "";
            cartClone!.properties["pickUpDate"] = initialPickUpDate || "";
            checkoutCart({
                cart: { ...cartClone },
                onSuccess() { }
            });
        }
    };

    const onAdiLockerModalClose = () => {
        setIsAdiLockerModalOpen(false);
    };

    const changeShippingAddressHandler = (address: ShipToModel, typeOfAddress?: string | undefined) => {
        dispatch({ type: "Custom/UpdateDeliveryMethod", result: "alternate" });
        setShippingSelection("alternate");
        setAddressId(address.id);
        setSelectedAltAddress(address);
        setStoreMoreOptionValue("");
        const shipToClone = cloneDeep(address);
        shipToClone.properties["selectasalternate"] = "Y";
        shipToClone.properties["isShipToSelected"] = "true";
        if (typeOfAddress === "newAddress") {
            shipToClone.properties["dropship"] = "1";
            shipToClone.properties["isDropShip"] = "True";
        }

        if (!isDGAndOverseas(address)) {
            try {
                setUpdateCartLoading({
                    loading: true,
                });
                updateShipTo({
                    billToId: billToId!,
                    shipTo: shipToClone,
                    isEdit: true,
                    properties: {
                        skipUpdateCart: true,
                        notLoadSession: true,
                    },
                    onSuccess: hasCartlines => {
                        if (!hasCartlines) {
                            history.push(cartPageLink!);
                        } else if (shipToClone.id !== "Create New") {
                            updateCartWithSelectedMethod(
                                false,
                                "",
                                "alternate",
                                selectedDeliveryMethodValue,
                                false,
                                shipToClone,
                            );
                        }
                    },
                    onComplete: (result: { apiResult: ShipToModel }) => {
                        if (result && result.apiResult) {
                            if (shipToClone.id === "Create New") {
                                const clone = cloneDeep(result.apiResult);
                                clone.validation = address.validation;
                                setSelectedAltAddress({ ...shipToClone, ...clone });
                                updateCartWithSelectedMethod(
                                    false,
                                    "",
                                    "alternate",
                                    selectedDeliveryMethodValue,
                                    false,
                                    result.apiResult,
                                );
                            }
                        }
                    },
                } as {
                    billToId: string;
                    shipTo: ShipToModel;
                    isEdit: boolean;
                    properties: any;
                } & HasOnSuccess<boolean>);
            } catch (error) {
                setUpdateCartLoading({
                    loading: false,
                });
            }
        } else {
            showDGpopup(false, address);
        }
    };

    const changeBillingAddressHandler = (address: BillToModel) => {
        updateBillTo({
            billTo: address,
            isEdit: true,
            onSuccess: hasCartlines => {
                if (!hasCartlines) {
                    history.push(cartPageLink!);
                }
            },
        });
    };

    const useBillingAddressHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        setCurrentShipTo({ shipToId: cart.billToId! });
    };

    const handleReset = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (event) event.preventDefault();
        setUpdateCartLoading({ loading: true });
        dispatch({ type: "Custom/UpdateDeliveryMethod", result: "primary" });
        updateCartWithSelectedMethod(false, "", "primary", selectedDeliveryMethodValue);
    };

    const oneHourPickupHandler = (isOneHourPickup: boolean, showBillOrder: boolean) => {
        let cartClone = JSON.parse(JSON.stringify(localCart));
        if (isOneHourPickup && isCodCustomer(cartClone)) {
            dispatch({ type: "Custom/UpdateOneHourPickup", result: "isOneHourPickUp" });
            dispatch({ type: "Custom/UpdatePaymentMethod", result: "showBill" });
            setAdiLockerCheck(false);
            cartClone!.properties["adiLockInd"] = "N";
        } else if (isOneHourPickup) {
            dispatch({ type: "Custom/UpdateOneHourPickup", result: "isOneHourPickUp" });
            dispatch({ type: "Custom/UpdatePaymentMethod", result: "showBill" });
            setAdiLockerCheck(false);
            cartClone!.properties["adiLockInd"] = "N";
        } else {
            dispatch({ type: "Custom/UpdateOneHourPickup", result: "" });
        }

        cartClone.properties["willCallRush"] = isOneHourPickup ? "Y" : "N";
        cartClone.properties["pickUpDate"] = localCart?.properties["pickUpDate"]
            ? localCart?.properties["pickUpDate"]
            : cartClone.properties["pickUpDate"];
        checkoutCart({
            cart: { ...cartClone },
            onSuccess() { }
        });
        setIsOneHourPickup(isOneHourPickup);
    };

    const handleStateChange: SelectProps["onChange"] = event => {
        const state = pickUpLocationStates?.find(s => s.value === event.target.value);
        setSelectedState(state);
        adiLockerHandler(false, state);
        handlePickUpInBranchLocationSelection(state!);
    };

    const handleShippingType: SelectProps["onChange"] = event => {
        setUpdateCartLoading({
            loading: true,
        });
        const cartClone = JSON.parse(JSON.stringify(cart!));
        cartClone.properties["shipPartial"] = event.target.value === "partialText" ? "true" : "false";
        setShippingType(event.target.value);
        cartClone.billTo = billToState.value;
        updateCart({
            cart: cartClone,
            onSuccess(result: ADIUpdateCartResult) {
                checkoutCart({
                    cart: { cart: { ...cartClone } } as unknown as CartModel,
                    onSuccess(latestresult: CheckoutCartParameter) {
                        setIsLoading(false);
                        setUpdateCartLoading({
                            loading: false,
                        });
                        loadCartSummary({ cart: { ...cartClone } as unknown as CartModel });
                    },
                });
                setInitialShippingMethodsLoaded(false);
            },
        });
    };

    const formatAsCurrency = (num: number) => {
        return num.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        });
    };

    const getUpdatedDeliveryMethod = (
        method: any,
        shippingMethodsResult: ShippingMethodsResults | null | undefined,
    ) => {
        return shippingMethodsResult?.deliveryCarrier.map((carrier: any) => {



            if (method?.car.trim() == carrier.cd.trim()) {
                ;
                const methodData = {
                    car: method.car,
                    cd: method.cd,
                    descr: method.descr,
                    def: method.def,
                    freightCost: method.freightCost,
                    frieghtTax: method.frieghtTax,
                    isTBD: method.isTBD,
                };
                if (carrier.thirdPartyOnFile.trim() != "") {
                    ;
                    if (method.descr.trim().indexOf(carrier.desc.trim()) >= 0) {
                        methodData.descr = method.descr.trim();
                    } else {
                        methodData.descr = carrier?.desc.trim() + " - " + method?.descr.trim();
                    }
                    methodData.freightCost = 0;
                } else if (method.isTBD) {
                    methodData.descr = carrier.desc.trim() + " - " + method.descr.trim() + " - " + "TBD";
                } else {

                    let descr =
                        carrier.desc.trim() +
                        " - " +
                        method.descr.trim() +
                        " - " +
                        (method.freightCost != 0 ? formatAsCurrency(method.freightCost).toString() : 'FREE')
                    // formatAsCurrency(method.freightCost).toString();
                    if (localStorage.getItem("IsFreeShip")) {
                        ;
                        let isFreeShip = localStorage.getItem("IsFreeShip");
                        if (
                            isFreeShip == "Yes" &&
                            method.descr.toUpperCase().indexOf("GROUND") >= 0 &&
                            method.freightCost == 0
                        ) {
                            descr = carrier.desc.trim() + " - " + method.descr.trim() + " - " + "FREE";
                        }
                        if (
                            isFreeShip == "Yes" &&
                            method.descr.toUpperCase().indexOf("STANDARD") >= 0 &&
                            method.freightCost == 0
                        ) {
                            descr = carrier.desc.trim() + " - " + method.descr.trim() + " - " + "FREE";
                        }
                    }
                    methodData.descr = descr;
                }
                if (method.cd.trim().indexOf(method.car.trim()) >= 0) {
                    methodData.cd = method.cd.trim();
                } else {
                    methodData.cd = method.cd.trim() + "|" + method.car.trim();
                }

                return methodData;
            }
        });
    };

    const getSelectedDescription = (car: any) => {
        const descriptionName = shippingMethods?.deliveryCarrier.find((item: any) => {
            if (item.cd.trim() === car.trim()) {
                return item;
            }
        });
        return descriptionName?.desc;
    };

    const handleOptionsClick = () => {
        if (!cartIsLoading) {
            setShowShippingOptions(prev => !prev);
        }
        setInitialMoreOptionLoaded(true)
        if (!showShippingOptions) {
            loadShippingMethods({
                apiparameter: {
                    accountLTLAllowed: cart?.accountLTLAllowed,
                    branchID: cart?.p21BranchCode,
                    cannotShipAir: cannotShipAirs,
                    carrierCodes: cart?.carrierCodes,
                    destinationCity: selectCity,
                    destinationCountry:
                        shippingSelectionState === "alternate"
                            ? selectedAltAddress?.country?.abbreviation || ""
                            : shipToState.value?.country?.abbreviation || "",
                    destinationState: selectState,
                    destinationZipCode: selectPostalCode,
                    freightOptions: cart?.freightOptions,
                    hasBulkItem: selectHasBulkItem,
                    mustShipLTL: selectHasShipLTL,
                    orderTotal: cart?.orderGrandTotal || 0,
                    orderWeight: selectShippingWeights,
                    overrideOriginCity: cart?.overrideOriginCity,
                    overrideOriginCountry: cart?.overrideOriginCountry,
                    overrideOriginState: cart?.overrideOriginState,
                    overrideOriginZipCode: cart?.overrideOriginZipCode,
                    overrideShipperID: cart?.overrideShipperID,
                    defaultCarrierCd: cart?.defaultCarrier,
                    getAllCarriers: true,
                },
                onSuccess(result: ShippingMethodsResults) {
                    const hasDefaultYes = result?.deliveryMethod?.find(item => item.def === "Y")?.descr.trim();
                    const indexOfItem = result?.deliveryMethod?.findIndex(item => item.def === "Y");
                    if (hasDefaultYes) {
                        let selectedOptions: any = getUpdatedDeliveryMethod(result.deliveryMethod[indexOfItem], result);
                        if (selectedOptions) {
                            for (let i = 0; i < selectedOptions?.length; i++) {
                                if (selectedOptions[i] != undefined) {
                                    selectedOptions = selectedOptions[i];
                                    break;
                                }
                            }
                            if (!storeMoreOptionValue || (storeMoreOptionValue === (hasDefaultYes + `_${indexOfItem}`))) {
                                setSelectedDeliveryMethodDisplay(selectedOptions);
                                setSelectedMoreOptionValue(hasDefaultYes + `_${indexOfItem}`);
                            } else {
                                setSelectedMoreOptionValue(storeMoreOptionValue);
                            }
                            setInitialMoreOptionLoaded(false)
                        }
                    }
                }
            });
        }
    };
    const shippingMethodsValue = () => {
        if (isPickUpSelected) {
            return "";
        }
        return selectedMoreOptionValue ? selectedMoreOptionValue : selectedDeliveryMethodValue;
    };


    return (
        <GridContainer {...styles.deliveryMethodContainer}>
            <RadioGroup
                value={shippingSelectionState}
                disabled={initialShippingMethodsLoaded}
                onChangeHandler={e => {
                    if (!cartIsLoading && !isCartUpdating) {
                        updateCartWithSelectedMethod(false, "", e.target.value, selectedDeliveryMethodValue);
                        setStoreMoreOptionValue("");
                    }
                }}
            >
                <GridContainer {...styles.radioContainer}>
                    <GridItem {...styles.shipAddressGridItem}>
                        <Radio disabled={isRadioDisabled || cartIsLoading} key="primary" value="primary">
                            {translate("Ship")}
                        </Radio>
                        {billToAddressFields && sessionShipTO.value && (
                            <GridItem {...styles.billingAddressGridItem}>
                                <ADIBillingAddress
                                    address={sessionShipTO.value}
                                    onChange={changeBillingAddressHandler}
                                    countries={countries}
                                    addressFieldDisplayCollection={billToAddressFields}
                                    extendedStyles={styles.billingAddress}
                                    billToObj={shitos}
                                    cartType={cart.type}
                                />
                            </GridItem>
                        )}
                    </GridItem>
                    <GridItem
                        {...(shippingSelectionState !== "pickup"
                            ? styles.alternateShipAddressGridItem
                            : styles.alternateShipAddressGridItemPickUp)}
                    >
                        <GridContainer>
                            <GridItem
                                {...(shippingSelectionState !== "pickup"
                                    ? styles.alternateShipLeftGrid
                                    : styles.alternateShipLeftGridPickUp)}
                            >
                                {shipTosDataView &&
                                    shipTosDataView.value &&
                                    shipTosDataView.value.length > 2 &&
                                    selectedAltAddress ? (
                                    <Radio
                                        disabled={isRadioDisabled || cartIsLoading}
                                        key="alternate"
                                        value="alternate"
                                    >
                                        {translate("Alternate Ship")}
                                    </Radio>
                                ) : null}
                            </GridItem>
                            <GridItem
                                {...(shippingSelectionState !== "pickup"
                                    ? styles.alternateShipRightGrid
                                    : styles.alternateShipRightGridPickUp)}
                            >
                                {shipTosDataView &&
                                    shipTosDataView.value &&
                                    shipTosDataView.value.length > 2 &&
                                    selectedAltAddress ? (
                                    <Link disabled={isRadioDisabled || cartIsLoading} onClick={editCustomerHandler}>
                                        Edit
                                    </Link>
                                ) : null}
                                {shipTosDataView &&
                                    shipTosDataView.value &&
                                    shipTosDataView.value.length > 2 &&
                                    selectedAltAddress ? (
                                    <Link disabled={isRadioDisabled || cartIsLoading} onClick={handleReset}>
                                        Clear
                                    </Link>
                                ) : null}
                                <EditExistingAddressModal
                                    newAddress={selectedAltAddress!}
                                    isModalOpen={isEditAddressModalOpen}
                                    onModalClose={editAddressModalCloseHandler}
                                    onFormSubmit={editAddressFormSubmitHandler}
                                />
                            </GridItem>
                            {showModal && (
                                <ADICannotShipModal
                                    headline={translate("Items Cannot Be Shipped to Your Address")}
                                    cart={cart}
                                    handleClose={modalCloseHandler}
                                    removeItemFunc={removeItem}
                                    returnToQuoteDetails={redirectToQuoteDetails}
                                    pickUpBranchFunc={() => {
                                        handlePickUpInBranchSelection(true);
                                    }}
                                    isOpen={showModal}
                                    {...styles.availabilityByWarehouseModal}
                                />
                            )}
                            <GridItem {...styles.shippingAddressGridItem}>
                                <ADIShippingAddress
                                    address={selectedAltAddress}
                                    currentBillToId={cart.billToId}
                                    countries={countries}
                                    addressFieldDisplayCollection={shipToAddressFields!}
                                    onChange={changeShippingAddressHandler}
                                    showUseBillingAddress={canUseBillToAsShipTo}
                                    isUseBillingAddressDisabled={isShipToSameAsBillTo}
                                    onClickUseBillingAddress={useBillingAddressHandler}
                                    extendedStyles={styles.shippingAddress}
                                    newAddress={newAddress}
                                    oneTimeAddress={oneTimeAddress}
                                    deliveryMethod={shippingSelectionState}
                                    isRadioDisabled={isRadioDisabled}
                                >
                                    {children}
                                </ADIShippingAddress>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridContainer {...styles.shippingMethodsContainer}>
                        <GridItem {...styles.shippingTitle}>
                            <Typography>{translate("Ship Method:")}</Typography>
                        </GridItem>
                        <GridItem {...styles.shippingContent}>
                            {shippingMethods?.deliveryCarrier?.length && shippingMethods.deliveryMethod?.length ? (
                                <Typography>
                                    <Typography {...styles.selectedTitle} as={"span"}>
                                        {`${selectedShippingMethodValue?.car
                                            ? getSelectedDescription(selectedShippingMethodValue?.car) + " - "
                                            : ""
                                            }  ${selectedShippingMethodValue?.descr
                                                ? selectedShippingMethodValue?.descr.trim()
                                                : ""
                                            } ${selectedShippingMethodValue?.isTBD
                                                ? `- TBD`
                                                : selectedShippingMethodValue?.freightCost! <= 0
                                                    ? `- Free`
                                                    : `${cart.currencySymbol && selectedShippingMethodValue?.freightCost
                                                        ? "- " + cart.currencySymbol
                                                        : ""
                                                    }${selectedShippingMethodValue?.freightCost
                                                        ? selectedShippingMethodValue?.freightCost
                                                        : ""
                                                    }`
                                            }
                                            `}

                                        {selectedDeliveryMethodDisplay && !isPickUpSelected && <>{replaceZeroPriceWithFree(selectedDeliveryMethodDisplay.descr)}</>}
                                    </Typography>

                                    <Typography
                                        {...styles.optionsTitle}
                                        onClick={handleOptionsClick}
                                    >
                                        {!showShippingOptions
                                            ? translate("+ More Options")
                                            : translate("- Hide Options")}
                                    </Typography>
                                </Typography>
                            ) : null}
                        </GridItem>
                        {showShippingOptions && (
                            <GridItem {...styles.shippingOptionsContainer}>
                                {shippingMethods?.deliveryCarrier &&
                                    shippingMethods?.deliveryCarrier.map(item => {
                                        return (
                                            <StyledWrapper
                                                key={item.cd + item.def + item.desc}
                                                {...(item.thirdPartyOnFile.trim() !== "" ? styles.shippingOptionsInnerContainer : styles.shippingUPSOptionsInnerContainer)}
                                            >
                                                <Typography as="h2" {...styles.carrierTitle}>
                                                    {item.thirdPartyOnFile.trim() !== "" ? (
                                                        <>
                                                            {translate("Freight account on file")}
                                                            <Tooltip
                                                                {...styles.tooltipStyles}
                                                                text={siteMessage(
                                                                    "Freight charges will be billed direct by the carrier on file.",
                                                                ).toString()}
                                                            />
                                                        </>
                                                    ) : (
                                                        item.desc
                                                    )}
                                                </Typography>
                                                <RadioGroup
                                                    name="shippingMethods"
                                                    value={shippingMethodsValue()}
                                                    onChangeHandler={setSelectedShipingMethod}
                                                    {...styles.radioGroupStyles}
                                                >
                                                    {shippingMethods?.deliveryMethod.map((method, index) => {


                                                        const deliveryValue = formatDeliveryMethodValue(method, item);


                                                        if (deliveryValue) {
                                                            return (
                                                                <Radio
                                                                    key={index + method.descr}
                                                                    {...styles.radioOptions}
                                                                    value={method.descr.trim() + `_${index}`}
                                                                    disabled={initialMoreOptionLoaded}
                                                                >
                                                                    {deliveryValue.descr}
                                                                </Radio>
                                                            );
                                                        }
                                                    })}
                                                </RadioGroup>
                                            </StyledWrapper>
                                        );
                                    })}
                            </GridItem>
                        )}
                        {shippingMethods?.deliveryCarrier[0]?.desc.trim() === "LTL" && shippingtotalweight() > 350 && (
                            <GridItem {...styles.ltlTextGrid}>
                                <Typography>
                                    {translate("Note: Due to order weight, this order must ship LTL.")}
                                </Typography>
                            </GridItem>
                        )}
                        {choosePreference() ? (
                            <>
                                <GridItem {...styles.shippingTitle}>
                                    <Typography>{translate("Choose preference:")}</Typography>
                                </GridItem>
                                <GridItem {...styles.shippingContent}>
                                    <Select
                                        {...styles.selectTime}
                                        value={shippingType}
                                        onChange={handleShippingType}
                                        disabled={cartIsLoading}
                                    >
                                        <option value="partialText">
                                            {translate("Ship products as they become available")}
                                        </option>
                                        <option value="completeText">{translate("Ship products all at once")}</option>
                                    </Select>
                                    {shippingType === "partialText" && (
                                        <Typography {...styles.shippingTypeText}>
                                            {translate("This may result in multiple shipments.")}
                                        </Typography>
                                    )}
                                    {shippingType === "completeText" && (
                                        <Typography {...styles.shippingTypeText}>
                                            {translate(
                                                "Your order will ship together. This may result in a shipping delay.",
                                            )}
                                        </Typography>
                                    )}
                                </GridItem>
                            </>
                        ) : null}
                    </GridContainer>
                    <StyledWrapper {...styles.customBorder}></StyledWrapper>
                    <GridItem
                        {...(shippingSelectionState !== "pickup"
                            ? styles.pickUpBranchGridItem
                            : styles.pickUpBranchGridItemPickUp)}
                    >
                        <GridContainer {...styles.pickUpContainer}>
                            <GridItem {...styles.pickUpRadioGridItem}>
                                <Radio key="pickup" value="pickup" disabled={cartIsLoading || isLbProductPresntInCart}>
                                    {translate("Pick Up in Branch")}
                                </Radio>
                            </GridItem>
                            <GridItem {...styles.pickUpBranchRightGridItem}>
                                <Select
                                    {...styles.stateStyles}
                                    name="branch"
                                    sizeVariant="small"
                                    disabled={!isPickUpSelected || cartIsLoading || isCartUpdating}
                                    onChange={handleStateChange}
                                    value={selectedState?.value || ""}
                                >
                                    {pickUpLocationStates?.map((state: any, index: number) => {
                                        const capitalizedTitle = state.title
                                            .toLowerCase()
                                            .split(" ")
                                            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
                                            .join(" ");

                                        return (
                                            state.title && (
                                                <option value={state.value} key={index}>
                                                    {capitalizedTitle}
                                                </option>
                                            )
                                        );
                                    })}
                                </Select>
                                {isLoading ? (
                                    <>
                                        <LoadingSpinner {...styles.spinner}></LoadingSpinner>
                                    </>
                                ) : (
                                    shippingSelectionState === "pickup" &&
                                    selectedState &&
                                    !cartIsLoading &&
                                    !isCartUpdating && (
                                        <ADIPickUpBranchDate
                                            datepickerStyles={styles.datepickerStyles}
                                            setPickUpDate={setPickUpDate}
                                            selectedState={selectedState}
                                            setIsShowOneHourPickup={setIsShowOneHourPickup}
                                            oneHourPickupHandler={oneHourPickupHandler}
                                            adiLockerCheck={adiLockerCheck}
                                            disabled={cartIsLoading}
                                        />
                                    )
                                )}
                            </GridItem>
                            {(shippingSelectionState === "pickup" && isShowOneHourPickup && !isPRRegion && (Number(cart?.properties?.companyCode) != 414)) && (
                                <GridItem {...styles.onehourCheckboxGridItem}>
                                    <Checkbox
                                        onChange={(e, value) => oneHourPickupHandler(value, true)}
                                        checked={isOneHourPickup}
                                        disabled={cartIsLoading}
                                    >
                                        "One-hour pickup"
                                    </Checkbox>
                                </GridItem>
                            )}
                            {shippingSelectionState === "pickup" &&
                                (selectedState?.adiLockInd === "Y" || selectedState?.adiLockInd === "L") ? (
                                <GridItem {...styles.pickUpCheckboxGridItem}>
                                    <Checkbox
                                        onChange={(e, value) => adiLockerHandler(value)}
                                        checked={adiLockerCheck}
                                        disabled={cartIsLoading}
                                    >
                                        "Pick up anytime at an ADI Locker"
                                    </Checkbox>
                                    <Link
                                        {...styles.pickUpStyles}
                                        onClick={() => window.open("/pick-up-anytime", "_blank")}
                                    >
                                        <Tooltip
                                            {...styles.tooltipStyles}
                                            text={siteMessage("Pick Up In Branch Help").toString()}
                                        />
                                    </Link>
                                </GridItem>
                            ) : null}
                            <Modal
                                {...styles.adiLockerModal}
                                headline="Pick up anytime at an ADI locker"
                                isOpen={isAdiLockerModalOpen}
                                handleClose={() => onAdiLockerModalClose()}
                                data-test-selector="AdiLockerModal"
                            >
                                <StyledWrapper {...styles.adiLockerBodyContainer}>
                                    <Typography as="p" className="firstLineText">
                                        You have selected <span>Pick Up Anytime at an ADI Locker.</span> Here's how it
                                        works:
                                    </Typography>
                                    <ul>
                                        <li>
                                            Your order can be picked up 24/7 at a self-service locker at the selected
                                            branch.
                                        </li>
                                        <li>
                                            You will receive an email with an access code and instructions when your
                                            order is ready for pickup.
                                        </li>
                                        <li>
                                            Don’t head to the branch before you receive this email; your order may not
                                            be ready.
                                        </li>
                                        <li>
                                            Orders will be processed the same business day if placed on a weekday before
                                            4 p.m. local time.
                                        </li>
                                        <li>
                                            Orders placed on weekends, holidays and weekdays after 4 p.m. will not be
                                            ready until the next business day.
                                        </li>
                                        <li>Items must be picked up within two business days.</li>
                                    </ul>
                                    <Typography as="p" className="forQuestionsText">
                                        For questions, contact web support at 1.877.228.6739.
                                    </Typography>
                                    <StyledWrapper {...styles.adiLockerButtonContainer}>
                                        <Button onClick={() => onAdiLockerModalClose()}>Continue Checkout</Button>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </Modal>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </RadioGroup>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ADICheckoutShippingAddresses)),
    definition: {
        group: "Checkout - Shipping",
        allowedContexts: ["CheckoutShippingPage", "CheckoutReviewAndSubmitPage"],
        displayName: "ADI Checkout Shipping Addresses",
    },
};

export default widgetModule;
